<!--Vista de checkout de eventos -->
<template>
  <v-container v-if="eventExists" fluid>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="9">
        <v-row>
          <v-col cols="12" class="pt-10">
            <v-img
              v-if="msConfig.banner"
              class="rounded-xl"
              :src="msConfig.banner"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <p class="headline text-center font-weight-bold mb-0">
              {{ eventName }}
            </p>
          </v-col>
          <v-col cols="12">
            <p
              class="title text-center grey--text font-weight-bold"
              :class="published ? '' : 'mb-0'"
            >
              Comprar accesos
            </p>
          </v-col>
          <v-col v-if="!published" cols="12" class="py-0">
            <p class="title red--text text-center font-weight-bold">
              Evento no disponible
            </p>
          </v-col>
          <v-col v-if="!canPurchase" cols="12" class="py-0">
            <p class="subtitle-1 red--text text-center font-weight-bold">
              {{ purchaseRestrictionMessage }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card
              class="px-3 pt-6 pb-2"
              rounded="xl"
              elevation="0"
              :style="`border: 1.7px solid ${msConfig.primaryColor}`"
              :disabled="!published"
            >
              <v-row class="px-5 px-md-15">
                <!--INICIO de Paso 1 de Checkout-->
                <v-col v-if="currentStep == 1" cols="12">
                  <v-row>
                    <v-col cols="12" class="pb-0 pt-10">
                      <p class="subtitle-1 mb-7">
                        <span class="font-weight-bold mr-4">
                          Paso {{ currentStep }} de 4
                        </span>
                        <span>
                          Selecciona la categoría del ticket y la cantidad que
                          quieres comprar
                        </span>
                      </p>
                    </v-col>
                    <v-col cols="12" class="pb-0 pt-4">
                      <p class="wc-h6 mb-7">
                        <span class="font-weight-bold mr-4">
                          Boletos Disponibles
                        </span>
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      class="access-item-border"
                      v-for="ticket in tickets"
                      :key="ticket.id"
                    >
                      <v-row>
                        <v-col cols="12" md="4" class="py-5 px-5 pl-md-10">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="#EFB810"
                                v-on="on"
                                v-bind="attrs"
                                v-if="ticket.membersOnly"
                              >
                                mdi-brightness-percent
                              </v-icon>
                            </template>
                            <span>Precio exclusivo para miembros activos</span>
                          </v-tooltip>

                          <span class="title font-weight-bold">
                            {{ ticket.name }}
                          </span>
                          <p class="body-2">{{ ticket.details }}</p>
                          <p
                            v-if="hideAccesscounter(ticket.event, ticket)"
                            class="subtitle-2 mb-0"
                            :class="
                              ticket.availableTicketsForSale == 0
                                ? 'red--text text--darken-1 font-weight-bold'
                                : ''
                            "
                          >
                            {{
                              ticket.availableTicketsForSale != 0
                                ? ticket.availableTicketsForSale +
                                  ' accesos disponibles.'
                                : 'Accesos agotados.'
                            }}
                          </p>
                          <p>
                            <span
                              v-if="
                                organizationId === '66fb2d896646ca001cb93b3f' &&
                                ticket.membersOnly &&
                                isTicketAlreadyPurchased(ticket.id) &&
                                 isActiveMember()
                              "
                              class="red--text text--darken-1 font-weight-bold subtitle-2"
                            >
                              Ya has comprado este boleto exclusivo para
                              miembros. Los boletos de miembros solo se pueden
                              comprar una vez por evento.
                            </span>
                            <span
                              v-else-if="
                                organizationId === '66fb2d896646ca001cb93b3f' &&
                                ticket.membersOnly &&
                                !isTicketAlreadyPurchased(ticket.id) &&
                                hasMembersOnlyTicketInCart() &&
                                 isActiveMember()
                              "
                              class="red--text text--darken-1 font-weight-bold subtitle-2"
                            >
                              Solo puedes comprar un boleto de miembro por
                              evento.
                            </span>
                          </p>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          xl="3"
                          offset-md="1"
                          class="py-5 px-5"
                        >
                          <p class="title font-weight-bold mb-0">Precio</p>
                          <p
                            v-if="paymentModality || ticket.price <= 0"
                            class="subtitle-1"
                          >
                            GRATIS
                          </p>
                          <p v-else class="subtitle-1">
                            {{ formatNumber(ticket.price) }}
                          </p>
                        </v-col>
                        <v-col cols="12" md="3" xl="2" class="px-5 pr-md-10">
                          <v-row>
                            <v-col cols="12" class="pb-1">
                              <p
                                class="title text-center font-weight-bold mb-0"
                              >
                                Cantidad:
                              </p>
                            </v-col>
                          </v-row>
                          <v-row justify="center" align="center">
                            <v-col
                              v-if="!isResumingOrder"
                              cols="4"
                              sm="3"
                              class="d-flex justify-center"
                            >
                              <v-btn
                                fab
                                x-small
                                color="primary"
                                depressed
                                :disabled="
                                   (!isActiveMember() ||
                                     !membersOnlyAffiliationTypeValidation(
                                       ticket.id
                                     )) &&
                                  ticket.membersOnly
                                "
                                @click="removeTicket(ticket.id)"
                              >
                                <v-icon>fas fa-minus</v-icon>
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="4"
                              sm="5"
                              class="d-flex text-center justify-center"
                            >
                              <span class="title font-weight-bold">
                                {{
                                  counterValues[ticket.id]
                                    ? counterValues[ticket.id]
                                    : 0
                                }}
                              </span>
                            </v-col>
                            <v-col
                              v-if="!isResumingOrder"
                              cols="4"
                              sm="3"
                              class="d-flex justify-center"
                            >
                              <v-btn
                                fab
                                x-small
                                color="primary"
                                :disabled="
                                  !canPurchase ||
                                  (!membersOnlyAffiliationTypeValidation(
                                    ticket.id
                                  ) ||
                                  hasMembersOnlyTicketInCart()) &&
                                  ticket.membersOnly &&
                                   isActiveMember()
                                "
                                depressed
                                @click="handleAddTicket(ticket)"
                              >
                                <v-icon>fas fa-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-if="!isResumingOrder" cols="12" class="pb-0 mt-6">
                      <p class="wc-h6 mb-7">
                        <span class="font-weight-bold mr-4">
                          Combos Disponibles
                        </span>
                      </p>
                    </v-col>
                    <v-col
                      v-if="!isResumingOrder"
                      cols="12"
                      class="access-item-border"
                      v-for="combo in combos"
                      :key="combo.id"
                    >
                      <v-row v-if="isActiveComboTicket(combo.ticket)">
                        <v-col cols="12" md="4" class="py-5 px-5 pl-md-10">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="#EFB810"
                                v-on="on"
                                v-bind="attrs"
                                v-if="isMembersOnly(combo.ticket)"
                              >
                                mdi-brightness-percent
                              </v-icon>
                            </template>
                            <span>Boleto exclusivo para miembros activos</span>
                          </v-tooltip>

                          <span class="title font-weight-bold">
                            {{ combo.name }}
                          </span>
                          <p class="body-2">{{ combo.description }}</p>
                          <p>
                            <span
                              v-if="
                                 !isActiveMember() &&
                                 isMembersOnly(combo.ticket)
                              "
                              class="red--text text--darken-1 font-weight-bold subtitle-2"
                            >
                              Para poder comprar este boleto es necesario ser
                              miembro activo. Si ya eres miembro activo,
                              <router-link
                                :to="`/login?event=${eventId}`"
                                class="red--text text--darken-1 font-weight-bold subtitle-2"
                                @click.native.prevent="openLoginDialog"
                              >
                                inicia sesión
                              </router-link>
                              para obtener tu precio especial.
                            </span>
                            <span
                              v-else-if="
                                organizationId === '66fb2d896646ca001cb93b3f' &&
                                isMembersOnly(combo.ticket) &&
                                isTicketAlreadyPurchased(combo.ticket) &&
                                 isActiveMember()
                              "
                              class="red--text text--darken-1 font-weight-bold subtitle-2"
                            >
                              Ya has comprado el boleto asociado a este combo.
                              Los boletos de miembros solo se pueden comprar una
                              vez por evento.
                            </span>
                            <span
                              v-else-if="
                                organizationId === '66fb2d896646ca001cb93b3f' &&
                                isMembersOnly(combo.ticket) &&
                                !isTicketAlreadyPurchased(combo.ticket) &&
                                hasMembersOnlyTicketInCart() &&
                                 isActiveMember()
                              "
                              class="red--text text--darken-1 font-weight-bold subtitle-2"
                            >
                              Solo puedes comprar un boleto de miembro por
                              evento.
                            </span>
                          </p>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          xl="3"
                          offset-md="1"
                          class="py-5 px-5"
                        >
                          <p class="title font-weight-bold mb-0">Boleto</p>
                          <p class="subtitle-1">
                            {{ ticketName(combo.ticket) }}
                          </p>
                        </v-col>
                        <v-col cols="12" md="3" xl="2" class="px-5 pr-md-10">
                          <v-row>
                            <v-col cols="12" class="pb-1">
                              <p
                                class="title text-center font-weight-bold mb-0"
                              >
                                Cantidad:
                              </p>
                            </v-col>
                          </v-row>
                          <v-row justify="center" align="center">
                            <v-col
                              cols="4"
                              sm="3"
                              class="d-flex justify-center"
                            >
                              <v-btn
                                fab
                                x-small
                                color="primary"
                                depressed
                                :disabled="
                                   !isActiveMember() &&
                                   isMembersOnly(combo.ticket)
                                "
                                @click="removeCombo(combo)"
                              >
                                <v-icon>fas fa-minus</v-icon>
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="4"
                              sm="5"
                              class="d-flex text-center justify-center"
                            >
                              <span class="title font-weight-bold">
                                {{
                                  selectedCombos[combo.id]
                                    ? selectedCombos[combo.id]
                                    : 0
                                }}
                              </span>
                            </v-col>
                            <v-col
                              cols="4"
                              sm="3"
                              class="d-flex justify-center"
                            >
                              <v-btn
                                fab
                                x-small
                                color="primary"
                                :disabled="
                                  !canPurchase ||
                                  avaliableCombos(
                                    combo.ticket,
                                    combo.discountedQuantity
                                  ) === 0 ||
                                  (isMembersOnly(combo.ticket) &&
                                    !canPurchaseMembersOnlyCombo(combo.ticket))
                                "
                                depressed
                                @click="handleAddCombo(combo)"
                              >
                                <v-icon>fas fa-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="mt-3">
                      <p>
                        {{ getLabelForAccess(maxTicketsUserCanBuy) }}
                      </p>
                    </v-col>
                    <!--Ocultar apartado del cupón si el evento es gratuito-->
                    <v-col v-if="!paymentModality" cols="12">
                      <v-row align="center">
                        <v-col cols="12" md="6" lg="4">
                          <v-tooltip top :disabled="!ticketsToBuyIsZero">
                            <template v-slot:activator="{ on }">
                              <v-row v-on="on">
                                <v-text-field
                                  class="mr-2"
                                  v-model="coupon"
                                  :disabled="
                                    ticketsToBuyIsZero || couponApplied
                                  "
                                  label="Cupón/Cortesía"
                                  required
                                  dense
                                  filled
                                  rounded
                                  :error="errors.coupon.error"
                                  :error-messages="errors.coupon.message"
                                  :success="success.coupon.success"
                                  :success-messages="success.coupon.message"
                                  prepend-inner-icon="fas fa-tags"
                                  v-on:keyup.enter="addCoupon"
                                />
                              </v-row>
                            </template>
                            <span>
                              Para poder ingresar un(a) cupón/cortesía es
                              necesario seleccionar un boleto.
                            </span>
                          </v-tooltip>
                        </v-col>
                        <v-col>
                          <v-btn
                            @click="addCoupon"
                            :disabled="ticketsToBuyIsZero || couponApplied"
                            color="secondary"
                            small
                            class="rounded-pill"
                          >
                            Aplicar
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="6" class="my-7">
                      <v-row>
                        <v-btn
                          class="mx-1"
                          color="primary"
                          text
                          rounded
                          :to="{ name: 'microsite', params: { eventId } }"
                        >
                          <span class="font-weight-bold">Cancelar</span>
                        </v-btn>
                        <v-btn
                          class="mx-1"
                          :color="msConfig.buttonColor"
                          :style="`color: ${msConfig.textButtonColor}`"
                          rounded
                          :disabled="ticketsToBuyIsZero"
                          @click="currentStep++"
                        >
                          <span class="font-weight-bold"> Continuar </span>
                        </v-btn>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      class="d-flex justify-end align-end pb-7"
                    >
                      <p v-if="paymentModality" class="headline mb-0">
                        <span class="font-weight-bold">Evento gratuito</span>
                      </p>
                      <p v-else class="headline mb-0">
                        <span class="font-weight-bold">Total: </span
                        >{{ totalPurchaseWithDiscount.string }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
                <!--FIN de Paso 1 de Checkout-->
                <!--INICIO de Paso 2 de Checkout-->
                <v-col v-if="currentStep === 2" cols="12">
                  <v-form ref="ticketsForm" v-model="validTicketsForm">
                    <v-row>
                      <v-col cols="12" class="pb-0 pt-10">
                        <p class="subtitle-1 mb-7">
                          <span class="font-weight-bold mr-4">
                            Paso {{ currentStep }} de 4
                          </span>
                          <span> Ingresa los datos de asistente </span>
                        </p>
                      </v-col>
                      <!--INICIO de v-expansion-panels para poner los datos de asistente-->
                      <v-col cols="12 pt-0 mb-5">
                        <v-expansion-panels multiple v-model="panel" flat>
                          <v-expansion-panel
                            class="elevation-1"
                            v-for="(ticket, index) in order.tickets"
                            :key="index"
                          >
                            <v-expansion-panel-header>
                              <p class="title font-weight-bold mb-0">
                                {{ ticket.name }}
                              </p>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col cols="12">
                                  <p class="font-weight-bold text-subtitle-1 mb-0">Datos básicos</p>
                                  <p class="text-caption grey--text text--darken-1 mt-1">Se trata de los campos mínimos que requiere el sistema para que puedas reservar o comprar un acceso.</p>
                                </v-col>
                                <v-col cols="12">
                                  <p class="font-weight-bold">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Verifica que tu email sea correcto, es ahí
                                    donde enviaremos tu confirmación de
                                    registro.
                                  </p>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                  <v-text-field
                                    v-model="ticket.attendeeInformation.name"
                                    label="Nombre(s)"
                                    :readonly="
                                      ticket.membersOnly &&
                                      isImefOrganization(organizationId)
                                    "
                                    :rules="fieldsValidations.name"
                                    filled
                                    rounded
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                  <v-text-field
                                    v-model="
                                      ticket.attendeeInformation.lastName
                                    "
                                    label="Apellidos"
                                    :readonly="
                                      ticket.membersOnly &&
                                      isImefOrganization(organizationId)
                                    "
                                    :rules="fieldsValidations.lastName"
                                    filled
                                    rounded
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                  <v-text-field
                                    v-model="ticket.attendeeInformation.email"
                                    label="E-mail"
                                    :readonly="
                                      ticket.membersOnly &&
                                      isImefOrganization(organizationId)
                                    "
                                    :rules="fieldsValidations.email"
                                    @keydown="formatEmail(ticket)"
                                    filled
                                    rounded
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                  <v-text-field
                                    v-model="
                                      ticket.attendeeInformation.confirmEmail
                                    "
                                    :rules="[
                                      (ticket.attendeeInformation.email ===
                                        ticket.attendeeInformation
                                          .confirmEmail &&
                                        ticket.attendeeInformation.email !==
                                          '' &&
                                        ticket.attendeeInformation
                                          .confirmEmail !== '') ||
                                        'La confirmación de e-mail no es correcta',
                                    ]"
                                    @keydown="formatEmail(ticket)"
                                    label="Confirmar e-mail"
                                    required
                                    filled
                                    rounded
                                  />
                                </v-col>
                                <!-- EXTRA FIELDS -->
                                <template
                                  v-if="ticket.registrationFields.length > 0"
                                >
                                  <!-- Stepper mode when sections exist -->
                                  <v-col v-if="hasSections(ticket)" cols="12">
                                    <v-stepper
                                      :value="currentTicketStep[ticket.id || ticket._id] || 1"
                                      alt-labels
                                      class="elevation-0"
                                    >
                                      <v-stepper-header style="box-shadow: none; border: 1px solid #e0e0e0; border-radius: 8px;">
                                        <template v-for="(step, si) in getTicketSteps(ticket)">
                                          <v-stepper-step
                                            :key="'step-header-' + si"
                                            :step="si + 1"
                                            :complete="(currentTicketStep[ticket.id || ticket._id] || 1) > si + 1"
                                          >{{ step.title || 'Campos sin sección' }}</v-stepper-step>
                                          <v-divider v-if="si < getTicketSteps(ticket).length - 1" :key="'step-divider-' + si" />
                                        </template>
                                      </v-stepper-header>
                                      <v-stepper-items>
                                        <v-stepper-content
                                          v-for="(step, si) in getTicketSteps(ticket)"
                                          :key="'step-content-' + si"
                                          :step="si + 1"
                                          class="pa-0"
                                        >
                                          <v-row class="pt-2">
                                            <template v-for="field in step.fields">
                                              <v-col
                                                :key="field._id"
                                                cols="12"
                                                sm="6"
                                                md="4"
                                                v-if="isCheckoutFieldVisible(field, ticket)"
                                              >
                                                <v-text-field
                                                  v-if="field.fieldType === 'TEXT'"
                                                  v-model="ticket.extraInfo[field.formattedName]"
                                                  :rules="field.required ? fieldsValidations.required : []"
                                                  :hint="field.description"
                                                  filled
                                                  rounded
                                                >
                                                  <template v-slot:label>
                                                    <span class="label_move">{{ field.name }}</span>
                                                  </template>
                                                </v-text-field>
                                                <v-select
                                                  v-if="field.fieldType === 'LIST' && !field.allowMultiple"
                                                  v-model="ticket.extraInfo[field.formattedName]"
                                                  :rules="field.required ? fieldsValidations.required : []"
                                                  :menu-props="{ zIndex: 100, top: true, offsetY: true }"
                                                  :hint="field.description"
                                                  :items="getCheckoutFieldItems(field, ticket)"
                                                  filled
                                                  rounded
                                                  @change="clearCheckoutChildFields(field, ticket)"
                                                >
                                                  <template v-slot:label>
                                                    <span class="label_move">{{ field.name }}</span>
                                                  </template>
                                                </v-select>
                                                <v-select
                                                  v-else-if="field.fieldType === 'LIST' && field.allowMultiple"
                                                  v-model="ticket.extraInfo[field.formattedName]"
                                                  :rules="field.required ? [(v) => (Array.isArray(v) && v.length > 0) || 'Este campo es requerido'] : []"
                                                  :menu-props="{ zIndex: 100, top: true, offsetY: true }"
                                                  :hint="field.description"
                                                  :items="getCheckoutFieldItems(field, ticket)"
                                                  multiple
                                                  small-chips
                                                  filled
                                                  rounded
                                                  @change="handleMultiSelectParentChange(field, ticket)"
                                                >
                                                  <template v-slot:label>
                                                    <span class="label_move">{{ field.name }}</span>
                                                  </template>
                                                </v-select>
                                                <v-file-input
                                                  v-if="field.fieldType == 'DOC' || field.fieldType == 'IMAGE'"
                                                  v-model="ticket.extraInfo[field.formattedName]"
                                                  :rules="field.fieldType == 'IMAGE' ? fileImageRules : field.fieldType == 'DOC' ? fileRules : ''"
                                                  show-size
                                                  :hint="field.description"
                                                  prepend-icon=""
                                                  prepend-inner-icon="$file"
                                                  persistent-hint
                                                  filled
                                                  rounded
                                                >
                                                  <template v-slot:label>
                                                    <span class="label_move">{{ field.name }}</span>
                                                  </template>
                                                </v-file-input>
                                              </v-col>
                                            </template>
                                          </v-row>
                                          <v-row class="mt-2 mb-1">
                                            <v-btn
                                              v-if="si > 0"
                                              text
                                              rounded
                                              class="mx-1"
                                              @click="prevTicketStep(ticket)"
                                            >Anterior</v-btn>
                                            <v-btn
                                              v-if="si < getTicketSteps(ticket).length - 1"
                                              color="primary"
                                              rounded
                                              class="mx-1"
                                              @click="nextTicketStep(ticket)"
                                            >Siguiente sección</v-btn>
                                          </v-row>
                                        </v-stepper-content>
                                      </v-stepper-items>
                                    </v-stepper>
                                  </v-col>
                                  <!-- Flat mode (no sections) -->
                                  <template v-else>
                                  <template
                                    v-for="field in getExpandedCheckoutFields(ticket)"
                                  >
                                  <v-col
                                    :key="field._instanceKey ? (field._id + '__' + field._instanceKey) : field._id"
                                    cols="12"
                                    sm="6"
                                    md="4"
                                    v-if="isCheckoutFieldVisible(field, ticket)"
                                  >
                                    <v-text-field
                                      v-if="field.fieldType === 'TEXT'"
                                      v-model="
                                        ticket.extraInfo[field.formattedName]
                                      "
                                      :rules="
                                        field.required
                                          ? fieldsValidations.required
                                          : []
                                      "
                                      :hint="field.description"
                                      filled
                                      rounded
                                    >
                                      <template v-slot:label>
                                        <span class="label_move">{{
                                          field.name
                                        }}</span>
                                      </template>
                                    </v-text-field>
                                    <v-select
                                      v-if="field.fieldType === 'LIST' && !field.allowMultiple"
                                      v-model="
                                        ticket.extraInfo[field.formattedName]
                                      "
                                      :rules="
                                        field.required
                                          ? fieldsValidations.required
                                          : []
                                      "
                                      :menu-props="{
                                        zIndex: 100,
                                        top: true,
                                        offsetY: true,
                                      }"
                                      :hint="field.description"
                                      :items="getCheckoutFieldItems(field, ticket)"
                                      filled
                                      rounded
                                      @change="clearCheckoutChildFields(field, ticket)"
                                    >
                                      <template v-slot:label>
                                        <span class="label_move">{{
                                          field._instanceLabel ? (field.name + ' — ' + field._instanceLabel) : field.name
                                        }}</span>
                                      </template>

                                    </v-select>
                                    <v-select
                                      v-else-if="field.fieldType === 'LIST' && field.allowMultiple"
                                      v-model="
                                        ticket.extraInfo[field.formattedName]
                                      "
                                      :rules="
                                        field.required
                                          ? [(v) => (Array.isArray(v) && v.length > 0) || 'Este campo es requerido']
                                          : []
                                      "
                                      :menu-props="{
                                        zIndex: 100,
                                        top: true,
                                        offsetY: true,
                                      }"
                                      :hint="field.description"
                                      :items="getCheckoutFieldItems(field, ticket)"
                                      multiple
                                      small-chips
                                      filled
                                      rounded
                                      @change="handleMultiSelectParentChange(field, ticket)"
                                    >
                                      <template v-slot:label>
                                        <span class="label_move">{{
                                          field.name
                                        }}</span>
                                      </template>
                                    </v-select>
                                    <v-file-input
                                      v-if="
                                        field.fieldType == 'DOC' ||
                                        field.fieldType == 'IMAGE'
                                      "
                                      v-model="
                                        ticket.extraInfo[field.formattedName]
                                      "
                                      :rules="
                                        field.fieldType == 'IMAGE'
                                          ? fileImageRules
                                          : field.fieldType == 'DOC'
                                          ? fileRules
                                          : ''
                                      "
                                      show-size
                                      :hint="field.description"
                                      prepend-icon=""
                                      prepend-inner-icon="$file"
                                      persistent-hint
                                      filled
                                      rounded
                                    >
                                      <template v-slot:label>
                                        <span class="label_move">{{
                                          field.name
                                        }}</span>
                                      </template>
                                    </v-file-input>
                                  </v-col>
                                  </template>
                                  </template>
                                </template>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                      <!--FIN de v-expansion-panels para poner los datos de asistente-->
                      <v-col cols="12" md="6" class="my-7">
                        <v-row>
                          <v-btn
                            class="mx-1"
                            color="primary"
                            text
                            rounded
                            @click="currentStep--"
                            ><span class="font-weight-bold"
                              >Regresar</span
                            ></v-btn
                          >
                          <v-btn
                            class="mx-1"
                            :color="msConfig.buttonColor"
                            :style="`color: ${msConfig.textButtonColor}`"
                            rounded
                            @click="setAttendeeInformation"
                          >
                            <span class="font-weight-bold">Continuar</span>
                          </v-btn>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        class="d-flex justify-end align-end pb-7"
                      >
                        <p v-if="paymentModality" class="headline mb-0">
                          <span class="font-weight-bold">Evento gratuito</span>
                        </p>
                        <p v-else class="headline mb-0">
                          <b>Total: </b>{{ totalPurchaseWithDiscount.string }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
                <!--FIN de Paso 2 de Checkout-->
                <!--INICIO de Paso 3 de Checkout-->
                <v-col v-if="currentStep === 3" cols="12">
                  <v-row>
                    <v-col cols="12" class="pb-0 pt-10">
                      <p class="subtitle-1 mb-7">
                        <span class="font-weight-bold mr-4"
                          >Paso {{ currentStep }} de 4 </span
                        ><span>Selecciona el método de pago</span>
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <v-item-group
                            v-model="order.paymentInformation.paymentMethod"
                          >
                            <v-row justify="center">
                              <v-col cols="12">
                                <h2 class="title font-weight-bold">
                                  Métodos de pago
                                </h2>
                              </v-col>
                              <template v-if="paymentMethods.length > 0">
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="3"
                                  v-for="(item, index) in paymentMethodList"
                                  :key="index"
                                >
                                  <v-item
                                    v-if="
                                      item.name !== 'BANK_TRANSFER'
                                        ? true
                                        : item.name === 'BANK_TRANSFER' &&
                                          (hasStripeConfig ||
                                            user.stripeAccountType == 'EXPRESS')
                                    "
                                    v-slot="{ active, toggle }"
                                    :value="item.name"
                                  >
                                    <v-card
                                      :color="
                                        active
                                          ? msConfig.buttonColor
                                          : 'elementBackGray'
                                      "
                                      class="pa-2 px-lg-3 py-lg-5 fill-height text-center"
                                      :style="`color: ${
                                        active ? msConfig.textButtonColor : ''
                                      }`"
                                      @click="
                                        paymentSelection(toggle, item.name)
                                      "
                                      rounded="xl"
                                      :elevation="active ? '2' : '0'"
                                    >
                                      <v-row
                                        justify="center"
                                        align="center"
                                        class="fill-height"
                                      >
                                        <v-col cols="12">
                                          <h2
                                            class="title font-weight-bold mb-5"
                                          >
                                            {{ setPaymentMethod(item.name) }}
                                          </h2>
                                          <v-icon
                                            :style="getSizePaymentsMethodsIcons"
                                            :color="
                                              active
                                                ? msConfig.textButtonColor
                                                : ''
                                            "
                                            >{{ item.icon }}</v-icon
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-item>
                                </v-col>
                              </template>
                              <v-col v-else>
                                <h3
                                  class="red--text text-center title font-weight-bold"
                                >
                                  No se encontraron métodos de pago
                                </h3>
                              </v-col>
                            </v-row>
                          </v-item-group>
                        </v-col>
                        <v-col
                          v-if="
                            order.paymentInformation.paymentMethod ===
                            paymentMethodsKeys.Cash
                          "
                          cols="12"
                          class="pb-0"
                        >
                          <p class="subtitle-1 primary--text font-weight-bold">
                            <v-icon color="amber">mdi-alert</v-icon> Los pagos
                            en OXXO se ven reflejados 24 horas después de haber
                            realizado el pago, por lo que recomendamos hacer el
                            pago a mas tardar 24 horas antes de que comience el
                            evento.
                          </p>
                          <!--<p class="subtitle-1">Los pagos en oxxo se ven reflejados 24 horas después de haber realizado el pago, por lo que recomendamos hacer el pago, a mas tardar 24 horas antes de que comience el evento.</p>-->
                        </v-col>

                        <v-col
                          v-if="
                            order.paymentInformation.paymentMethod ===
                            paymentMethodsKeys.BankTransfer
                          "
                          cols="12"
                          class="pb-0"
                        >
                          <p
                            class="subtitle-1 primary--text font-weight-bold"
                            color="red"
                          >
                            <v-icon color="amber">mdi-alert</v-icon> Los pagos
                            mediante transferencia bancaria se ven reflejados 24
                            horas después de haber realizado el pago, por lo que
                            recomendamos hacer el pago a mas tardar 24 horas
                            antes de que comience el evento.
                          </p>
                          <p class="subtitle-1 primary--text font-weight-bold">
                            <v-icon color="amber">mdi-alert</v-icon> Esta CLABE
                            interbancaria es DESECHABLE, única y exclusiva para
                            esta transacción, favor de no compartirla, ni
                            guardarla en la App de tu banco. Al terminar la
                            operación se INVALIDARÁ y NO se podrá usar más. Si
                            la vuelves a usar tu dinero se podría perder.
                          </p>

                          <!--<p class="subtitle-1">Los pagos en oxxo se ven reflejados 24 horas después de haber realizado el pago, por lo que recomendamos hacer el pago, a mas tardar 24 horas antes de que comience el evento.</p>-->
                        </v-col>

                        <!-- Información de Peibo -->
                        <v-col
                          v-if="
                            order.paymentInformation.paymentMethod ===
                            paymentMethodsKeys.Peibo
                          "
                          cols="12"
                          class="pb-0"
                        >
                          <p class="subtitle-1 primary--text font-weight-bold">
                            <v-icon color="amber">mdi-alert</v-icon> Los pagos
                            mediante Peibo se reflejan en un plazo de 24 a 48
                            horas hábiles. Recibirás una CLABE interbancaria
                            exclusiva para esta transacción.
                          </p>
                        </v-col>

                        <!-- Formulario de beneficiario Peibo (solo si el usuario no tiene CLABE registrada) -->
                        <v-col
                          v-if="
                            order.paymentInformation.paymentMethod ===
                              paymentMethodsKeys.Peibo && user && !user.peiboClabe
                          "
                          cols="12"
                          class="pt-0 mt-3"
                        >
                          <v-row justify="center">
                            <v-col cols="12">
                              <h3 class="title font-weight-bold">
                                Información del beneficiario
                              </h3>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                label="Nombre completo"
                                v-model="peiboData.beneficiary_name"
                                required
                                prepend-inner-icon="fas fa-user"
                                filled
                                rounded
                              />
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                label="RFC"
                                v-model="peiboData.beneficiary_tax_id"
                                required
                                prepend-inner-icon="fas fa-id-card"
                                filled
                                rounded
                              />
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" class="pt-0 mt-5">
                          <v-row justify="center">
                            <v-col cols="12">
                              <h3 class="title font-weight-bold">
                                Información del comprador
                              </h3>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                label="Nombre(s)"
                                v-model="order.paymentInformation.name"
                                required
                                prepend-inner-icon="fas fa-user"
                                filled
                                rounded
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                label="Apellidos"
                                v-model="order.paymentInformation.lastName"
                                required
                                prepend-inner-icon="fas fa-user"
                                filled
                                rounded
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                label="E-mail"
                                v-model="order.paymentInformation.email"
                                required
                                prepend-inner-icon="fas fa-envelope"
                                filled
                                rounded
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          v-if="
                            order.paymentInformation.paymentMethod ===
                            paymentMethodsKeys.CreditCard
                          "
                          cols="12"
                          class="pt-0 mt-5"
                        >
                          <v-row justify="center">
                            <v-col cols="12">
                              <h3 class="title font-weight-bold">
                                Información de la tarjeta
                              </h3>
                            </v-col>
                            <v-col cols="12" md="12" sm="6">
                              <v-text-field
                                v-model="order.paymentInformation.cardName"
                                type="text"
                                name="name"
                                label="Nombre(s) del titular"
                                required
                                prepend-inner-icon="fas fa-user"
                                filled
                                rounded
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-stripe-card
                                v-model="source"
                                :api-key="apiKey"
                                :stripeAccount="stripeAccount"
                                :hidePostalCode="true"
                                :key="stripeComponentKey"
                                :disabled="!order.paymentInformation.cardName"
                                ref="stripeRef"
                              />
                            </v-col>
                            <v-col v-if="false" cols="12" class="pt-0">
                              <v-switch
                                label="Quiero pagar con meses sin intereses."
                                :color="msConfig.primaryColor"
                                hide-details
                                class="mt-0"
                              ></v-switch>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          v-if="
                            installments.plans.length > 0 &&
                            order.paymentInformation.paymentMethod ===
                              paymentMethodsKeys.CreditCard
                          "
                          cols="12"
                          class="pt-0 mt-3"
                        >
                          <v-row justiify="center">
                            <v-col cols="12" md="12" sm="6">
                              <h3 class="title font-weight-bold">
                                Meses sin intereses
                              </h3>
                            </v-col>
                            <v-col cols="12">
                              <v-card>
                                <v-list>
                                  <v-list-item-group
                                    v-model="installments.selected"
                                  >
                                    <v-list-item
                                      v-for="(item, i) in installments.plans"
                                      :key="i"
                                      :value="item"
                                    >
                                      <template #default="{ active }">
                                        <v-list-item-content class="d-flex">
                                          <v-list-item-title>
                                            <v-checkbox
                                              class="mt-0"
                                              hide-details
                                              :label="`${item.count} meses`"
                                              :input-value="active"
                                            />
                                            <!-- <span>
                                          {{ item.count }}
                                          {{
                                            item.interval === "month"
                                              ? "meses"
                                              : "N/A"
                                          }}
                                        </span> -->
                                          </v-list-item-title>
                                          <!-- <v-list-item-title>
                                          {{ item.count }}
                                          {{
                                            item.interval === "month"
                                              ? "meses"
                                              : "N/A"
                                          }}
                                        </v-list-item-title> -->
                                        </v-list-item-content>
                                      </template>
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <!-- IMEF: alert message -->
                          <v-col cols="12" v-if="isImefOrganization(organizationId) && order.paymentInformation.paymentMethod === paymentMethodsKeys.CreditCard" class="d-flex align-start">
                            <v-icon color="amber" class="mr-2">
                              mdi-alert
                            </v-icon>
                            <p class="subtitle-1 primary--text font-weight-bold">
                              Una vez que capture la información, presione la tecla TAB de su teclado para que el sistema reconozca que es tarjeta de crédito y habilite los meses sin intereses.
                            </p>
                          </v-col>
                        <!-- IMEF -->
                        <v-col
                          cols="12"
                          class="pb-0"
                          v-if="
                            this.tickets[0].event !==
                              '650b6097df1055001b68aa77' && offerBilling
                          "
                        >
                          <h2 class="title font-weight-bold">Facturación</h2>
                        </v-col>
                        <v-col
                          cols="12"
                          class="d-flex pt-0"
                          v-if="
                            this.tickets[0].event !==
                              '650b6097df1055001b68aa77' && offerBilling
                          "
                        >
                          <v-checkbox
                            hide-details
                            @click="declineBill = false"
                            class="mr-4"
                            v-model="acceptBill"
                            :color="msConfig.active"
                          >
                            <template v-slot:label>
                              <span class="d-flex align-center pa-0"
                                >Quiero facturar mi compra</span
                              >
                            </template>
                          </v-checkbox>
                          <v-checkbox
                            hide-details
                            class="mr-3"
                            @click="acceptBill = false"
                            v-model="declineBill"
                            :color="msConfig.active"
                          >
                            <template v-slot:label>
                              <span class="d-flex align-center pa-0"
                                >No quiero facturar mi compra</span
                              >
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col
                          cols="12"
                          class="py-0 d-flex"
                          v-if="
                            this.tickets[0].event !==
                              '650b6097df1055001b68aa77' && offerBilling
                          "
                        >
                          <p v-if="acceptBill">
                            <span
                              v-if="
                                [
                                  '62b622c66a7441ae20159d7d',
                                  '6297b0fec7bf8b6f826313be',
                                ].includes(organizationId) && offerBilling
                              "
                            >
                              <v-icon color="red">mdi-alert</v-icon>
                              Tendrás hasta el final del día de hoy (11:59 pm)
                              para generar tu factura usando el ID que recibirás
                              en el correo de confirmación.
                            </span>

                            <span v-else>
                              <b>Nota:</b> Tendrás hasta fin de mes para generar
                              tu factura usando el ID que recibirás en el correo
                              de confirmación
                            </span>
                          </p>
                          <p v-else-if="declineBill">
                            <b>Atención:</b> si eliges esta opción debes estar
                            seguro, ya que no podrás facturar esta compra en el
                            futuro.
                          </p>
                          <p v-else style="color: red; font-weight: bold">
                            * Debe seleccionar una opción para continuar
                          </p>
                        </v-col>
                        <!---->

                        <v-col
                          cols="12"
                          class="pt-0"
                          v-if="
                            [
                              '62b622c66a7441ae20159d7d',
                              '6297b0fec7bf8b6f826313be',
                            ].includes(organizationId) && offerBilling
                          "
                        >
                          <v-checkbox
                            v-model="billingPolitics.terms"
                            :color="msConfig.active"
                            hide-details
                          >
                            <template v-slot:label>
                              <span>
                                Acepto las&nbsp;
                                <router-link
                                  to="/politicas-de-facturacion"
                                  v-slot="{ href }"
                                >
                                  <a :href="href" target="_blank" @click.stop
                                    >Políticas de Facturación.
                                  </a>
                                </router-link>
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <!---->

                        <v-col cols="12" class="pt-0">
                          <v-checkbox
                            v-model="termsOfUSe.terms"
                            :color="msConfig.active"
                            hide-details
                          >
                            <template v-slot:label>
                              <span>
                                Acepto los&nbsp;
                                <router-link
                                  to="/terminos-y-condiciones"
                                  v-slot="{ href }"
                                >
                                  <a :href="href" target="_blank" @click.stop
                                    >Términos y Condiciones
                                  </a>
                                </router-link>
                                &nbsp;y el&nbsp;
                                <router-link
                                  to="/aviso-de-privacidad"
                                  v-slot="{ href }"
                                >
                                  <a :href="href" target="_blank" @click.stop
                                    >Aviso de Privacidad.</a
                                  >
                                </router-link>
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col
                          cols="12"
                          class="pt-0 d-flex align-start"
                          v-if="isImefOrganization(organizationId)"
                        >
                          <v-checkbox
                            class="ma-0"
                            v-model="shareDataPolitics.terms"
                            :color="msConfig.active"
                            hide-details
                          />
                          <p class="mb-0">
                            IMEF y sus patrocinadores pueden utilizar mis datos
                            de contacto para mantenerme informado de eventos,
                            servicios y ofertas. Para retirar su consentimiento
                            enviar correo a gvillagran@imef.org.mx. Conocer más
                            en
                            <router-link to="/politicas-imef" v-slot="{ href }">
                              <a :href="href" target="_blank" @click.stop>
                                Política de datos personales.
                              </a>
                            </router-link>
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="6" class="my-7">
                      <v-row>
                        <v-btn
                          class="mx-1"
                          color="primary"
                          text
                          rounded
                          @click="
                            paymentModality
                              ? (currentStep = currentStep - 2)
                              : currentStep--
                          "
                        >
                          <span class="font-weight-bold">Regresar</span>
                        </v-btn>
                        <v-btn
                          class="mx-1"
                          :color="msConfig.buttonColor"
                          :style="`color: ${msConfig.textButtonColor}`"
                          rounded
                          @click="executePaymentAction"
                          :disabled="disableContinueBuyButton"
                        >
                          <span class="font-weight-bold">Continuar</span>
                        </v-btn>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      class="d-flex justify-end align-end pb-7"
                    >
                      <p v-if="paymentModality" class="headline mb-0">
                        <span class="font-weight-bold">Evento gratuito</span>
                      </p>
                      <p v-else class="headline mb-0">
                        <span class="font-weight-bold">Total: </span
                        >{{ totalPurchaseWithDiscount.string }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
                <!--FIN de Paso 3 de Checkout-->
                <!--INICIO de Paso 4 de Checkout-->
                <v-col v-if="currentStep == 4" cols="12">
                  <v-row>
                    <v-col cols="12" class="pb-0 pt-10">
                      <p class="subtitle-1 mb-7">
                        <span class="font-wordereight-bold mr-4"
                          >Paso {{ currentStep }} de 4 </span
                        ><span>Revisa los datos de tu compra</span>
                      </p>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <p class="headline font-weight-bold">Resumen</p>
                    </v-col>
                    <v-col v-if="order.items.length > 0" cols="12">
                      <!-- <v-row class="text-center" justify="center">
                        <v-col cols="12" md="6">
                          <h2 class="title font-weight-bold">Tipo de acceso</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Precio U.</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Cantidad</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Subtotal</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Facturación</h2>
                        </v-col>
                      </v-row> -->
                      <v-row
                        v-for="ticket in order.items"
                        :key="ticket.id"
                        class="text-center"
                        justify="center"
                      >
                        <v-col cols="6" md="2">
                          <h2 class="title font-weight-bold">Tipo de acceso</h2>
                          <p class="subtitle-1 mb-0">
                            {{ ticket.name }}
                          </p>
                        </v-col>
                        <v-col cols="6" md="2">
                          <h2 class="title font-weight-bold">Precio U.</h2>
                          <p class="subtitle-1 mb-0">
                            {{ formatNumber(ticket.price) }}
                          </p>
                        </v-col>
                        <v-col cols="6" md="2">
                          <h2 class="title font-weight-bold">Cantidad</h2>
                          <p class="subtitle-1 mb-0">
                            {{ ticket.quantity }}
                          </p>
                        </v-col>
                        <v-col cols="6" md="2">
                          <h2 class="title font-weight-bold">Subtotal</h2>
                          <p class="subtitle-1 mb-0">
                            {{ formatNumber(ticketSubtotal(ticket.id)) }}
                          </p>
                        </v-col>
                        <v-col cols="6" md="2">
                          <h2 class="title font-weight-bold">Facturación</h2>
                          <p class="subtitle-1 mb-0">
                            {{
                              order.paymentInformation.needsInvoice
                                ? 'Si'
                                : 'No'
                            }}
                          </p>
                        </v-col>
                        <v-col cols="12">
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="order.coupon.id"
                        class="text-center"
                        align="center"
                        justify="start"
                      >
                        <v-col cols="6" sm="3">
                          <h2 class="title font-weight-bold">Cupón Aplicado</h2>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <h2 class="title font-weight-bold">
                            Porcentaje de Descuento
                          </h2>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <h2 class="title font-weight-bold">
                            Cantidad de Descuento
                          </h2>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="order.coupon.id"
                        class="text-center"
                        justify="start"
                      >
                        <v-col cols="6" sm="3">
                          <p class="subtitle-1 mb-0">
                            {{ order.coupon.code }}
                          </p>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <p class="subtitle-1 mb-0">
                            {{ order.coupon.percentOff }}%
                          </p>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <p class="subtitle-1 mb-0">
                            {{ discount.string }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" md="6" class="my-9">
                      <v-row>
                        <v-btn
                          class="mx-1"
                          color="primary"
                          text
                          rounded
                          @click="returnFromStepFour"
                          ><span class="font-weight-bold">Regresar</span></v-btn
                        >
                        <v-btn
                          class="mx-1"
                          :color="msConfig.buttonColor"
                          :style="`color: ${msConfig.textButtonColor}`"
                          rounded
                          @click="finishBuying"
                        >
                          <span class="font-weight-bold">Finalizar</span>
                        </v-btn>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      class="d-flex justify-end align-end pb-7"
                    >
                      <p class="headline mb-0">
                        <span class="font-weight-bold">Total: </span
                        >{{ totalPurchaseWithDiscount.string }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
                <!--FIN de Paso 4 de Checkout-->
                <!--INICIO de última sección del Checkout-->
                <v-col v-if="currentStep == 5" cols="12" class="pb-10">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-row justify="center" class="mb-5">
                        <v-icon :style="getSizeFinalIcon"
                          >mdi-email-newsletter</v-icon
                        >
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="text-center pt-0">
                      <p class="headline font-weight-bold text-uppercase">
                        ¡Muchas gracias!
                      </p>
                      <!-- Para pagos con tarjeta, que usaron cupón/cortesía del 100% o el boleto costaba $0.00 -->
                      <p
                        v-if="
                          totalPurchaseWithDiscount.number === 0 ||
                          order.paymentInformation.paymentMethod ===
                            paymentMethodsKeys.CreditCard
                        "
                        class="subtitle-1 mb-3"
                      >
                        El registro se ha realizado exitosamente, consulte su
                        correo electrónico para obtener sus acceso(s).
                      </p>
                      <!-- Para referencias de SPEI y OXXO -->
                      <p v-else class="subtitle-1 mb-3">
                        El registro se ha realizado exitosamente, consulte su
                        correo electrónico para obtener su referencia de pago.
                      </p>
                      <!-- Para cualquier tipo de registro -->
                      <p class="subtitle-1 mb-3" style="color: #17c6e9">
                        En ocasiones tu configuración de seguridad envía algunos
                        correos a SPAM, no olvides revisar ahí.
                      </p>
                      <p
                        v-if="
                          order.coupon.percentOff != 100 &&
                          !paymentModality &&
                          order.paymentInformation.needsInvoice
                        "
                        class="subtitle-1"
                      >
                        El id de tu orden es el siguiente <b>{{ order.id }}</b
                        >, te recomendamos guardarlo, ya que te servirá para
                        generar la factura de tu compra. <br />
                        {{
                          order.paymentInformation.paymentMethod ===
                          paymentMethodsKeys.CreditCard
                            ? 'Puedes generar la factura haciendo click en el botón a continuación.'
                            : ''
                        }}
                      </p>
                      <div
                        v-if="
                          order.coupon.percentOff != 100 &&
                          !paymentModality &&
                          order.paymentInformation.needsInvoice &&
                          order.paymentInformation.paymentMethod ===
                            paymentMethodsKeys.CreditCard
                        "
                      >
                        <v-btn
                          large
                          class="mx-1 font-weight-bold my-2 mb-6 pa-5"
                          :color="msConfig.buttonColor"
                          :style="`color: ${msConfig.textButtonColor}`"
                          target="_blank"
                          :href="`/facturacion-cliente/${order.id}`"
                          rounded
                        >
                          Generar Factura
                        </v-btn>
                      </div>
                      <p
                        v-if="
                          [
                            '62b622c66a7441ae20159d7d',
                            '6297b0fec7bf8b6f826313be',
                          ].includes(organizationId) &&
                          order.coupon.percentOff != 100 &&
                          !paymentModality &&
                          order.paymentInformation.needsInvoice
                        "
                        class="subtitle-1 mb-3"
                      >
                        <v-icon color="red">mdi-alert</v-icon>
                        Tendrás hasta el final del día de hoy (11:59 pm) para
                        generar tu factura usando el ID que recibirás en el
                        correo de confirmación.
                      </p>
                      <p
                        class="headline text-uppercase font-weight-bold"
                        :class="order.total === '0' ? 'text-center' : ''"
                      >
                        Resumen
                      </p>
                      <h4
                        v-if="
                          order.paymentInformation.paymentMethod ===
                          paymentMethodsKeys.BankTransfer
                        "
                        style="color: #ff0000"
                      >
                        Recuerda que tienes hasta las {{ dateExpireOrder }} para
                        realizar tu pago.
                      </h4>
                    </v-col>
                    <v-col v-if="order.items.length > 0" cols="12">
                      <v-row class="text-center" justify="center">
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Tipo de acceso</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Precio U.</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Cantidad</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Subtotal</h2>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <h2 class="title font-weight-bold">Facturación</h2>
                        </v-col>
                      </v-row>
                      <v-row
                        v-for="(ticket, index) in order.items"
                        :key="ticket.id"
                        class="text-center"
                        justify="center"
                      >
                        <v-col cols="6" sm="2">
                          <p class="subtitle-1 mb-0">
                            {{ ticket.name }}
                          </p>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <p class="subtitle-1 mb-0">
                            {{ formatNumber(ticket.price) }}
                          </p>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <p class="subtitle-1 mb-0">
                            {{ ticket.quantity }}
                          </p>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <p class="subtitle-1 mb-0">
                            {{ formatNumber(ticket.quantity * ticket.price) }}
                          </p>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <p class="subtitle-1 mb-0">
                            {{
                              order.paymentInformation.needsInvoice
                                ? 'Si'
                                : 'No'
                            }}
                          </p>
                        </v-col>
                        <v-col
                          v-if="index !== order.items.length - 1"
                          cols="12"
                        >
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="order.coupon.id"
                        class="text-center"
                        align="center"
                        justify="start"
                      >
                        <v-col cols="12">
                          <v-divider />
                        </v-col>
                        <v-col cols="6" sm="3">
                          <h2 class="title font-weight-bold">Cupón Aplicado</h2>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <h2 class="title font-weight-bold">
                            Porcentaje de Descuento
                          </h2>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <h2 class="title font-weight-bold">
                            Cantidad de Descuento
                          </h2>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="order.coupon.id"
                        class="text-center"
                        justify="start"
                      >
                        <v-col cols="6" sm="3">
                          <p class="subtitle-1 mb-0">
                            {{ order.coupon.code }}
                          </p>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <p class="subtitle-1 mb-0">
                            {{ order.coupon.percentOff }}%
                          </p>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <p class="subtitle-1 mb-0">
                            {{ discount.string }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <!--FIN de última sección del Checkout-->
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="my-10">
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <v-img
          max-width="150"
          height="auto"
          src="@/assets/images/weChamber/poweredby.svg"
        ></v-img>
      </v-col>
    </v-row>
    <!---------------------------------------DIALOGS DE CHECKOUT--------------------------------------------->
    <v-dialog v-model="iframeDialog" persistent max-width="700">
      <v-card>
        <iframe
          v-if="iframeSource"
          :src="iframeSource"
          width="100%"
          height="400"
          frameborder="0"
        >
        </iframe>
      </v-card>
    </v-dialog>

    <!--Dialogs de facturación-->
    <v-dialog v-model="facturaDialog" persistent max-width="400">
      <v-card>
        <v-card-text class="px-1 rounded-xl">
          <v-container>
            <v-row justify="center">
              <v-col cols="12" class="pt-8">
                <v-row justify="center">
                  <v-icon :color="msConfig.primaryColor" :style="getBigSize"
                    >fas fa-question-circle</v-icon
                  >
                </v-row>
              </v-col>
              <v-col cols="12" class="text-center">
                <h2 class="headline font-weight-bold">
                  ¿Cómo obtengo mi factura?
                </h2>
                <p>
                  Solo debes registrar tus datos fiscales en este apartado.
                  Recibirás de forma automática tu factura vía correo
                  electrónico una vez finalizada tu compra.
                </p>
                <v-row justify="center" class="pt-3">
                  <v-btn
                    color="primary"
                    @click="(factura = true), (facturaDialog = false)"
                    rounded
                    >Aceptar</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <modal-template
      :open="isOpenErrorCardModal"
      width="600"
      :secondaryBtnProps="{
        show: true,
        text: 'Cerrar',
        textColor: 'white',
        color: 'accent',
      }"
      @close="closeErrorCardModal"
    >
      <template #content>
        <v-row justify="center">
          <v-col cols="10" md="7" class="mt-8 d-flex justify-center">
            <v-img
              class=""
              src="@/assets/images/weChamber/logo-WC-microsite.svg"
              max-width="60"
              height="auto"
              contain
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mt-2">
            <p class="text-center font-weight-bold title mb-0">
              No se ha podido finalizar el pago
            </p>
          </v-col>
          <v-col cols="12" class="py-0">
            <p class="subtitle-1 text-center mb-0">{{ errorMessage }}</p>
          </v-col>
          <v-col cols="12" class="pt-0" v-if="errorCode != 'incorrect_cvc'">
            <p
              class="subtitle-1 text-center mb-0 secondary--text font-weight-bold"
            >
              {{ errorCode }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="errorCode != ''">
          <v-col cols="12">
            <p class="subtitle-1 text-center">
              Para más información sobre el código de error, puede ingresar al
              siguiente link:
              <a href="https://stripe.com/docs/error-codes" target="_blank"
                >Códigos de error de pago con tarjetas</a
              >
            </p>
          </v-col>
        </v-row>
      </template>
    </modal-template>
    <v-snackbar v-model="snackbar" :timeout="5000" :color="'error'" right top>
      <v-icon color="white">mdi-domain</v-icon>

      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <PersonalizedDialog
      :dialog="voucherDialog"
      @save="closeVoucherDialog"
      hide-name
      hide-button
      hide-image
    >
      <template #alertContent>
        <voucherCard
          :instructions="bankTransferInstructions"
          :description="bankTransferDescription"
          :beneficiary="organizationCompany"
        ></voucherCard>
      </template>
      <template #button> Finalizar </template>
    </PersonalizedDialog>

    <!-- Dialog para mostrar instrucciones de pago con Peibo -->
    <PersonalizedDialog
      :dialog="peiboDialog"
      @save="closePeiboDialog"
      hide-name
      hide-button
      hide-image
    >
      <template #alertContent>
        <PeiboInstructions
          :clabe="peiboClabe"
          :beneficiary="organizationCompany"
          :paymentConcept="order.id"
          :amount="totalPurchaseWithDiscount.string"
          :expirationDate="dateExpireOrder"
        />
      </template>
      <template #button> Finalizar </template>
    </PersonalizedDialog>

    <!-- Modal: boleto exclusivo para miembros -->
    <v-dialog v-model="memberOnlyModal" max-width="480">
      <v-card class="rounded-xl pa-2">
        <v-btn
          icon
          absolute
          style="top:8px;right:8px"
          @click="memberOnlyModal = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text class="pt-10 pb-4 text-center">
          <v-icon color="#EFB810" size="48" class="mb-3">mdi-brightness-percent</v-icon>
          <p class="title font-weight-bold mb-2">Precio especial para miembros</p>
          <p class="body-2 grey--text text--darken-1">
            Este boleto tiene un precio exclusivo para miembros activos de la organización.
            Si ya cuentas con una membresía activa, inicia sesión para acceder a este precio especial.
          </p>
        </v-card-text>
        <v-card-actions class="pb-6 px-6 d-flex flex-wrap justify-center" style="gap:12px">
          <v-btn
            color="primary"
            rounded
            depressed
            @click="openLoginDialog"
          >
            Soy miembro
          </v-btn>
          <v-btn
            v-if="enableMemberRegistration && orgAffiliationId"
            color="secondary"
            rounded
            depressed
            @click="$router.push(`/affiliation-checkout/${orgAffiliationId}`)"
          >
            Quiero ser miembro
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de login para miembros: permite autenticarse sin salir del checkout -->
    <LoginDialog
      v-model="showLoginDialog"
      :event-id="eventId"
      @logged-in="handleLoggedIn"
      @recover-password="handleRecoverPassword"
    />
  </v-container>
  <!--Mostrar este apartado si no existe el evento que se quiere mostrar-->
  <v-container v-else-if="!loaderVisible && !eventExists" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-row justify="center" align="center" class="mt-10 text-center">
          <v-col cols="12" sm="4" lg="5">
            <v-row justify="center">
              <v-img
                src="@/assets/images/weChamber/imagotype-WeChamber.jpg"
                width="100%"
                height="auto"
                contain
              ></v-img>
            </v-row>
          </v-col>
          <v-col cols="12" class="mt-10">
            <h1 class="display-1 font-weight-bold">
              ¡El evento que buscas no se encontró!
            </h1>
          </v-col>
          <v-col cols="12">
            <h1 class="display-12">404</h1>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="font-weight-bold"
              x-large
              color="secondary"
              rounded
              to="/"
            >
              Ir al inicio
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
//import VStripeCard from "v-stripe-elements/lib/VStripeCard";
import moment from 'moment';
import VStripeCard from '@/components/v-stripe-elements/lib/VStripeCard';
import { validations } from '@/share/validations';
import Endpoints from '@/share/Endpoints';
import { formatPrice, groupFieldsBySection } from '@/utils';
import { mapState, mapMutations, mapActions } from 'vuex';
import CardErrors from '@/share/cardErrorCodes';
import ModalTemplate from '@/components/shared/ModalTemplate';
import BillingTerms from '../../components/dashboard/billing/billingTerms.vue';
import PersonalizedDialog from '../../components/shared/PersonalizedDialog.vue';
import voucherCard from '../../components/shared/customerInstructions/voucherCard.vue';
import PeiboInstructions from '../../components/shared/PeiboInstructions.vue';
import LoginDialog from '@/components/shared/LoginDialog.vue';
import { isImefOrganization, isAsofomOrganization } from '../../share/imef';

export default {
  components: {
    ModalTemplate,
    VStripeCard,
    PersonalizedDialog,
    voucherCard,
    BillingTerms,
    PeiboInstructions,
    LoginDialog,
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
    ticketFilter: {
      type: String,
      default: null,
    },
    pendingOrderId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      affiliationTypes: [],
      offerBilling: false,
      selectedCombos: {},
      combos: [],
      apiKey: process.env.VUE_APP_STRIPE_API_KEY,
      iframeSource: '',
      stripeAccount: '',
      organizationId: '',
      organizationStripeConnectId: '',
      hasStripeConfig: false,
      acceptBill: false,
      declineBill: false,
      eventExists: true,
      source: null,
      validTicketsForm: false,
      currentStep: 1,
      voucherDialog: false,
      peiboDialog: false,
      peiboClabe: null,
      peiboData: {
        beneficiary_name: '',
        beneficiary_tax_id: '',
      },
      bankTransferInstructions: {},
      bankTransferDescription: '',
      coupon: '',
      couponApplied: false,
      panel: [0],
      ticketSections: {},
      currentTicketStep: {},
      termsOfUSe: {
        terms: false,
        receiveInfo: false,
      },
      // guardar solo para imef
      shareDataPolitics: {
        terms: false,
        receiveInfo: false,
      },
      billingPolitics: {
        terms: false,
        receiveInfo: false,
      },
      fieldsValidations: {
        name: validations.nameValidation({
          required: true,
        }),
        lastName: validations.nameValidation({
          name: 'apellidos',
          required: true,
        }),
        email: validations.emailValidation({
          required: true,
        }),
        required: validations.requiredMValidation(),
      },
      errors: {
        coupon: {
          error: false,
          message: '',
        },
      },
      success: {
        coupon: {
          success: false,
          message: '',
        },
      },
      factura: false,
      facturaDialog: false,
      iframeDialog: false,
      eventName: '',
      paymentModality: false,
      published: true,
      canPurchase: true,
      purchaseRestrictionMessage: 'No tienes permisos para comprar boletos de este evento.',
      ticketsToBuy: 0,
      maxTicketsUserCanBuy: 5,
      msConfig: {
        banner: '',
        primaryColor: '',
        buttonColor: '',
        textButtonColor: 'white',
      },
      tickets: [],
      paymentMethods: [],
      hideEventAccess: [
        '650342d7f0dcd5001bca42ff', //new
        '646510f1372b0b001be1a673',
        '64650ea0372b0b001be1a5b5',
        '64650dfe84e61b001aaa8ecb',
      ],
      purchasedMembersOnlyTickets: [], // Array de IDs de tickets membersOnly ya comprados
      paymentMethodsKeys: {
        Free: 'FREE',
        Cash: 'CASH',
        CreditCard: 'CREDIT_CARD',
        BankTransfer: 'BANK_TRANSFER',
        Peibo: 'PEIBO',
      },
      installments: {
        selected: null,
        plans: [],
        enable: false,
      },
      eventInstallmentsSelected: [],
      // Objecto que guardará los datos de la transacción
      order: {
        coupon: {
          id: '',
          percentOff: 0,
          limit: null,
          endDate: '',
          applications: 0,
        },
        id: '',
        items: [],
        paymentInformation: {
          name: '',
          lastName: '',
          email: '',
          paymentMethod: null,
          needsInvoice: false,
          cardName: '',
        },
        tickets: [],
      },
      cardPaymentIntentId: '',
      total: 0,
      snackbar: false,
      snackbarText: 'PlaceHolder',
      stripeComponentKey: 0,
      clientSecret: '',
      errorMessage: '',
      errorCode: '',
      isOpenErrorCardModal: false,
      fileRules: validations.fileValidation(),
      fileImageRules: validations.imageFileValidation(),
      organizationCompany: '',
      renewOrderIntervalId : null,
      currentOrderWHToken: null,
      lockedTicketId: null,
      memberOnlyModal: false,
      orgAffiliationId: null,
      enableMemberRegistration: false,
      showLoginDialog: false,
    };
  },
  watch: {
    'order.tickets': {
      deep: false,
      handler(tickets) {
        tickets.forEach((ticket) => {
          const id = ticket.id || ticket._id;
          if (id && !(id in this.ticketSections)) {
            this.loadTicketSections(id);
          }
        });
      },
    },
    currentStep(current) {
      if (current === 3) {
        const { name, lastName, email } = this.order.paymentInformation;
        const { attendeeInformation } = this.order.tickets[0];
        !name &&
          (this.order.paymentInformation.name = attendeeInformation.name);
        !lastName &&
          (this.order.paymentInformation.lastName =
            attendeeInformation.lastName);
        !email &&
          (this.order.paymentInformation.email = attendeeInformation.email);
        this.cardPaymentIntentId = '';
      }
    },
    source: async function () {
      try {
        this.loading();
        const { card, stripe } = this.$refs.stripeRef;
        const { paymentMethod } = await stripe.createPaymentMethod({
          type: 'card',
          card,
          billing_details: {
            name: this.order.paymentInformation.cardName,
            email: this.order.paymentInformation.email,
          },
        });
        const { data } = await this.axios({
          method: 'post',
          url: Endpoints.cardPayementIntent,
          data: {
            paymentMethod: { id: paymentMethod.id, total: this.total },
            orderId: this.order.id,
            cardCountry: paymentMethod.card.country,
          },
        });

        const {
          paymentIntent: { availablePlans = [], id: paymentIntentId },
        } = data;

        // this.installments.plans = data.paymentIntent.availablePlans;
        if (availablePlans.length && [...availablePlans].length <= 0) {
          this.installments.plans = [];
          this.installments.selected = null;
        }

        if (this.installments.enable && availablePlans.length > 0) {
          this.installments.plans = [...this.eventInstallmentsSelected].reduce(
            (accum, plan) => {
              if (
                this.totalPurchaseWithDiscount.number >=
                parseInt(plan.count) * 100
              ) {
                accum = [...accum, plan];
                return accum;
              }
              return accum;
            },
            []
          );
          if (this.eventId == '6626b791a9e76a001ce4d142') {
            this.installments.plans = [
              {
                count: 3,
                interval: 'month',
                type: 'fixed_count',
              },
              {
                count: 6,
                interval: 'month',
                type: 'fixed_count',
              },
            ];
          }
        }

        this.cardPaymentIntentId = paymentIntentId;
      } catch (error) {
        // this.errorMessage = error;
        // this.isOpenErrorCardModal = true;
        console.log('******** Card validation ***********');
        if (
          error.response.data.error.message ==
          'Por favor revise la información de los asistentes'
        ) {
          this.errorMessage =
            'Por favor revise la información de los asistentes';
          this.isOpenErrorCardModal = true;
          this.currentStep--;
        }
        console.log(error.response.data);
      } finally {
        this.loaded();
      }
    },
  },
  methods: {
    ...mapMutations('notification', ['show']),
    ...mapMutations('loader', ['loading', 'loaded']),
    ...mapMutations('order', ['deleteEventWebHookToken', 'setEventWebHookToken']),
    ...mapActions('order', ['fetchMemberPendingOrderById']),
    ...mapActions('formSections', ['getFormSectionsByTicket']),
    isImefOrganization,
    isActiveMember() {
      return Boolean(
        this.user &&
        ['MEMBER', 'MEMBERSHIP_USER'].includes(this.user.role) &&
        this.user.validationStatus === 'ACTIVE'
      );
    },
    isMemberUser() {
      return Boolean(
        this.user &&
        ['MEMBER', 'MEMBERSHIP_USER'].includes(this.user.role)
      );
    },
    openLoginDialog() {
      this.memberOnlyModal = false;
      this.showLoginDialog = true;
    },
    async handleLoggedIn() {
      this.loading();
      let success = false;
      try {
        const ok = await this.setEventInfo();
        success = ok === true && this.canPurchase === true;
      } catch (error) {
        console.error('[checkout][post-login][refetch]', error);
      } finally {
        this.loaded();
      }

      this.$gtag.event('user-login', {
        event_category: 'User Interaction',
        event_label: 'User login from checkout',
        value: 1,
      });

      if (success) {
        this.$router.push(`/member/eventCheckout/${this.eventId}`);
        return;
      }

      this.show({
        text: 'No tienes permisos para comprar accesos a este evento',
        color: 'error',
        time: 6000,
      });
      this.$router.push('/member/home');
    },
    handleRecoverPassword() {
      this.$router.push('/recuperar-contrasena');
    },
    isActiveComboTicket(ticketId) {
      const ticket = this.tickets.find((ticket) => ticket.id === ticketId);

      if (ticket && ticket !== null) {
        return true;
      } else {
        return false;
      }
    },
    getAffiliationTypeName(typeId) {
      return this.affiliationTypes.find((type) => type.id === typeId).name;
    },
    async getAffiliationTypes() {
      try {
        const response = await this.axios({
          method: 'GET',
          url: 'affiliation-types/member',
        });

        this.affiliationTypes = response.data.affiliationTypes;
      } catch (error) {
        console.log(error);
      }
    },
    membersOnlyAffiliationTypeValidation(ticketId) {
      const ticket = this.tickets.find((ticket) => ticket.id === ticketId);
      if (!ticket || !this.isActiveMember()) return false;
      if (ticket.membersOnlyAffiliationType) {
        return (
          ticket.membersOnlyAffiliationType == this.user.assignedMembership
        );
      } else {
        return true;
      }
    },
    ticketSubtotal(ticketId) {
      const tickets = this.order.tickets.filter(
        (ticket) => ticket.id === ticketId
      );

      let subtotal = 0;

      for (let ticket of tickets) {
        subtotal += ticket.price;
      }

      return subtotal;
    },
    avaliableCombos(ticketId, quantity) {
      const ticket = this.tickets.find((ticket) => ticket.id === ticketId);
      let avaliable = ticket.availableTicketsForSale / quantity;
      return parseInt(avaliable);
    },
    ticketName(ticketId) {
      return this.tickets.find((ticket) => ticket.id === ticketId).name;
    },
    isMembersOnly(ticketId) {
      return this.tickets.find((ticket) => ticket.id === ticketId).membersOnly;
    },
    isTicketAlreadyPurchased(ticketId) {
      // Solo aplicar esta funcionalidad para la organización específica
      if (this.organizationId !== '66fb2d896646ca001cb93b3f') {
        return false;
      }

      const ticket = this.tickets.find((ticket) => ticket.id === ticketId);
      // Solo verificar compras previas para tickets membersOnly
      if (ticket && ticket.membersOnly) {
        return this.purchasedMembersOnlyTickets.includes(ticketId);
      }
      return false;
    },
    canPurchaseMembersOnlyTicket(ticketId) {
      // Solo aplicar esta funcionalidad para la organización específica
      if (this.organizationId !== '66fb2d896646ca001cb93b3f') {
        return true;
      }

      const ticket = this.tickets.find((ticket) => ticket.id === ticketId);

      // Si no es membersOnly, se puede comprar sin restricciones
      if (!ticket || !ticket.membersOnly) return true;

      if (this.isMemberUser() && !this.isActiveMember()) return false;

      // Para tickets membersOnly, verificar si ya fue comprado previamente
      if (this.isTicketAlreadyPurchased(ticketId)) return false;

      // Verificar si ya tiene un boleto de miembro en el carrito actual
      if (this.hasMembersOnlyTicketInCart()) return false;

      // Si es membersOnly, no ha sido comprado previamente y no tiene otro en el carrito, se puede comprar
      return true;
    },
    canPurchaseMembersOnlyCombo(comboTicketId) {
      return this.canPurchaseMembersOnlyTicket(comboTicketId);
    },
    hasMembersOnlyTicketInCart() {
      // Solo aplicar esta funcionalidad para la organización específica
      if (this.organizationId !== '66fb2d896646ca001cb93b3f') {
        return false;
      }

      return this.order.tickets.some((orderTicket) => {
        const cartTicket = this.tickets.find((t) => t.id === orderTicket.id);
        return cartTicket && cartTicket.membersOnly;
      });
    },
    async getCombos() {
      try {
        const response = await this.axios({
          url: `/combos/${this.eventId}`,
          method: 'GET',
        });

        this.combos = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getMemberPurchasedTickets() {
      try {
        // Solo aplicar esta funcionalidad para la organización específica
        if (this.organizationId !== '66fb2d896646ca001cb93b3f') {
          return;
        }

        if (
          this.user &&
          this.user._id &&
          this.isActiveMember()
        ) {
          const response = await this.axios({
            url: `/items/member/${this.user._id}`,
            method: 'GET',
            params: {
              event: this.eventId,
            },
          });

          if (response.data && response.data.items) {
            // Procesar los items para extraer todos los tickets ya comprados
            const purchasedTicketIds = new Set();

            response.data.items.forEach((item) => {
              if (item.ticket) {
                purchasedTicketIds.add(item.ticket);
              }
            });

            this.purchasedMembersOnlyTickets = Array.from(purchasedTicketIds);
            console.log(
              'Tickets ya comprados por el usuario:',
              this.purchasedMembersOnlyTickets
            );
          }
        }
      } catch (error) {
        console.log('Error al obtener tickets comprados:', error);
      }
    },
    formatNumber(number) {
      return formatPrice(number);
    },
    getLabelForAccess(maxAccess = 0) {
      return `\(Máximo ${maxAccess} ${
        maxAccess > 1 ? 'accesos' : 'acceso'
      } por compra\)`;
    },
    hideAccesscounter(eventId, ticket) {
      let finalHideAccess = false;

      if (ticket.hidAccess || this.hideEventAccess.includes(eventId)) {
        finalHideAccess = false;
      } else {
        finalHideAccess = true;
      }

      return finalHideAccess;
    },
    getValueInOrgData(arrayObject, id) {
      let findIndex = arrayObject.findIndex((item) => item.id == id);
      console.log(arrayObject[findIndex]);
      return arrayObject[findIndex];
    },
    async getMethodPaymentActive(userID) {
      const response = await this.axios.get(
        Endpoints.excecuteGetMethodPayment.replace(/:userID/, userID)
      );
      const { data } = response;
      this.hasStripeConfig =
        this.getValueInOrgData(data.methods, 'bank_transfer_payments')?.active ||
        this.getValueInOrgData(data.methods, 'mx_bank_transfer_payments')
          ?.active || false;
    },
    validateTicketsForm() {
      if (this.$refs.ticketsForm.validate()) {
        this.currentStep++;
      }
    },
    setPaymentMethod(paymentName) {
      const { Cash, CreditCard, BankTransfer, Peibo } = this.paymentMethodsKeys;
      const cases = {
        [Cash]: 'Efectivo (Oxxo)',
        [CreditCard]: 'Tarjeta de Crédito/Débito',
        [BankTransfer]: 'Transferencia Bancaria SPEI',
        [Peibo]: 'Peibo',
      };
      return cases[paymentName] || '';
    },
    validate3sSecure: async function (e) {
      if (e.data === '3DS-authentication-complete') {
        console.log('Hola');
        this.iframeDialog = false;

        //this.loading();

        let stripe;
        if (this.stripeAccount) {
          stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY, {
            stripeAccount: this.stripeAccount,
          });
        } else {
          stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY);
        }

        await stripe.retrievePaymentIntent(this.clientSecret).then((result) => {
          if (result.error) {
            this.errorMessage =
              'El pago falló porque el banco emisor lo rechazó. Comunicate con el banco emisor para obtener más información.';
            this.errorCode = '';
            this.isOpenErrorCardModal = true;
            this.currentStep--;
            this.stripeComponentKey++;
            this.order.paymentInformation.cardName = '';
            this.termsOfUSe.terms = false;
            this.billingPolitics.terms = false;
            this.source = '';
            this.loaded();
          } else {
            if (result.paymentIntent.status === 'succeeded') {
              this.show({
                text: 'Registro realizado correctamente',
                color: 'primary',
              });
              this.currentStep++;
              this.loaded();
            } else if (
              result.paymentIntent.status === 'requires_payment_method'
            ) {
              this.errorMessage = '¡No se ha podido realizar la transacción!';
              this.errorCode = '';
              this.isOpenErrorCardModal = true;
              this.currentStep--;
              this.stripeComponentKey++;
              this.order.paymentInformation.cardName = '';
              this.termsOfUSe.terms = false;
              this.billingPolitics.terms = false;
              this.source = '';
              this.loaded();
            }
          }
        });
      }
    },
    formatTickets(tickets) {
      return tickets;
    },
    async setEventInfo() {
      try {
        const response = await this.axios.get(
          Endpoints.checkoutEvent.replace(/:eventId/, this.eventId)
        );

        if (response.status > 199 && response.status < 300) {
          const {
            name,
            tickets,
            ticketsPerOrder,
            paymentMethods,
            banner,
            paymentModality,
            published,
            installments = false,
            installmentsSelected,
            organization: { stripeConnectId, id, stripeAccountType, company, affiliationInfo },
            micrositeConfiguration: {
              primaryColor,
              buttonColor,
              textButtonColor,
            },
            offerBilling,
          } = response.data.checkoutInformation;
          const purchaseAccess = response.data.purchaseAccess || {};

          this.orgAffiliationId = affiliationInfo ? affiliationInfo.id : null;
          this.enableMemberRegistration = affiliationInfo ? affiliationInfo.enableMemberRegistration : false;

          this.offerBilling = offerBilling;
          this.eventExists = true;
          this.eventName = name;
          this.paymentModality = paymentModality;
          this.published = true;
          this.canPurchase = purchaseAccess.allowed !== false;
          this.purchaseRestrictionMessage =
            purchaseAccess.message ||
            'No tienes permisos para comprar boletos de este evento.';
          this.tickets = this.formatTickets(tickets);
          // Filter to specific ticket when coming from pending orders
          if (this.ticketFilter) {
            const filtered = this.tickets.filter(t => String(t.id) === String(this.ticketFilter) || String(t._id) === String(this.ticketFilter));
            if (filtered.length > 0) {
              this.tickets = filtered;
            }
          }
          // When resuming a pending order, lock to the ticket already assigned in the order
          this.applyTicketLockFilter();
          this.maxTicketsUserCanBuy = ticketsPerOrder;
          this.installments.enable = installments;
          this.eventInstallmentsSelected = [...installmentsSelected];
          this.stripeAccount =
            stripeAccountType == 'STANDARD' ? stripeConnectId : null;
          this.organizationStripeConnectId = stripeConnectId;
          this.organizationId = id;
          this.organizationCompany = company;
          // Filtrar los métodos de pago
          this.paymentMethods = paymentMethods.filter(
            (method) => method.active == true
          );
          this.msConfig = {
            banner,
            primaryColor,
            buttonColor,
            textButtonColor,
          };
          if (this.isImefOrganization(this.organizationId)) {
            this.shareDataPolitics.terms = true;
          }
          if (!this.paymentModality) {
            await this.getMethodPaymentActive(
              response.data.checkoutInformation.organization._id
            );
          }
          return true;
        }
        return false;
      } catch (error) {
        // this.$router.push({ name: '404' });
        console.log('--------------------');
        console.log(error);
        this.eventExists = false;
        return false;
      }
    },
    handleAddTicket(ticket) {
      if (!this.canPurchase) {
        this.show({
          text: this.purchaseRestrictionMessage,
          color: 'error',
        });
        return;
      }
      const isNonMember = !this.isActiveMember();
      if (ticket.membersOnly && isNonMember) {
        this.memberOnlyModal = true;
      } else {
        this.addTicket(ticket);
      }
    },
    handleAddCombo(combo) {
      if (!this.canPurchase) {
        this.show({
          text: this.purchaseRestrictionMessage,
          color: 'error',
        });
        return;
      }
      const isNonMember = !this.isActiveMember();
      if (isNonMember && this.isMembersOnly(combo.ticket)) {
        this.memberOnlyModal = true;
      } else {
        this.addCombo(combo);
      }
    },
    async setTickets() {
      try {
        const response = await this.axios.get(
          Endpoints.checkoutTicket.replace(/:eventId/, this.eventId)
        );
        if (response.status === 200) {
          const { data } = response;
          this.tickets = this.formatTickets(data.tickets);
        }
      } catch ({ message }) {}
    },

    async createOrder() {
      try {
        const response = await this.axios.post(Endpoints.checkoutCreateOrder, {
          order: { event: this.eventId },
        });
        if (response.status === 200) {
          this.order.id = response.data.order.id;
          this.currentOrderWHToken = response.data.whOrderExpiration;
          this.setEventWebHookToken(this.currentOrderWHToken)
        }
      } catch ({ message }) {}
    },
    /**
     * Re-applies the locked ticket filter (used in resume-order mode) so any
     * subsequent reassignment of `this.tickets` does not show other ticket types.
     */
    applyTicketLockFilter() {
      if (!this.lockedTicketId) return;
      const filtered = this.tickets.filter(
        (t) => String(t.id) === String(this.lockedTicketId) || String(t._id) === String(this.lockedTicketId)
      );
      if (filtered.length > 0) {
        this.tickets = filtered;
      }
    },
    /**
     * Loads an existing PAYMENT_PENDING order from the backend and hydrates the
     * checkout state so the member can finish paying without recreating the order.
     * Only one ticket of the assigned type is shown, with quantity fixed to 1
     * and no +/- selectors.
     */
    async hydrateFromPendingOrder() {
      const result = await this.fetchMemberPendingOrderById(this.pendingOrderId);
      if (!result || !result.status || !result.order) {
        this.show({
          text: 'No se pudo cargar la orden pendiente. Intenta nuevamente.',
          color: 'error',
        });
        return false;
      }
      const pendingOrder = result.order;
      const items = Array.isArray(pendingOrder.items) ? pendingOrder.items : [];
      const firstItem = items[0];
      if (!firstItem || !firstItem.ticket) {
        this.show({
          text: 'La orden pendiente no contiene un boleto válido.',
          color: 'error',
        });
        return false;
      }

      const ticket = firstItem.ticket;
      const ticketId = ticket._id || ticket.id;
      this.lockedTicketId = ticketId;
      this.order.id = pendingOrder._id;

      // Fix quantity to 1 regardless of how many items the admin created
      const attendeeInfo = firstItem.attendeeInformation || {};
      const registrationFields = ticket.registrationFields || [];
      const extraInfo =
        registrationFields.length > 0 ? this.getExtraInfo(registrationFields) : {};

      this.order.tickets = [
        {
          id: ticketId,
          itemId: firstItem._id,
          price: ticket.price || 0,
          name: ticket.name || '',
          registrationFields,
          extraInfo,
          attendeeInformation: {
            name: attendeeInfo.name || '',
            lastName: attendeeInfo.lastName || '',
            email: attendeeInfo.email || '',
            confirmEmail: attendeeInfo.email || '',
          },
          membersOnly: !!ticket.membersOnly,
        },
      ];
      this.order.items = [
        {
          id: ticketId,
          name: ticket.name || '',
          price: ticket.price || 0,
          quantity: 1,
        },
      ];
      this.ticketsToBuy = 1;
      this.panel = [0];

      // Lock visible tickets to the resumed ticket
      this.applyTicketLockFilter();
      return true;
    },
    /**
     * @param {string} ticketId - Ticket id to find in tickets array
     * @returns {Object} Ticket object with id, quantity, name, modality, price, etc.
     */
    getTicketById(ticketId, ticketsArray) {
      console.log('TICKET ID', ticketId);
      console.log('TICKETS ARRAY', ticketsArray);
      return ticketsArray.find((ticket) => ticket.id == ticketId);
    },
    getTicketQuantityById(ticketId, ticketsArray) {
      return this.getTicketById(ticketId, ticketsArray).quantity;
    },
    async isTicketAvailable(ticketId) {
      const { quantity } = this.getTicketById(ticketId, this.tickets);
      if (quantity > 0) {
        this.setTickets();
        const { quantity: availableQty } = this.getTicketById(
          ticketId,
          this.tickets
        );
        if (availableQty > 0) return true;
      }
      return false;
    },
    async loadTicketSections(ticketId) {
      const res = await this.getFormSectionsByTicket(ticketId);
      if (res.status) {
        this.$set(this.ticketSections, ticketId, res.data.sections || []);
        this.$set(this.currentTicketStep, ticketId, 1);
      }
    },
    getTicketSteps(ticket) {
      const ticketId = ticket.id || ticket._id;
      const sections = this.ticketSections[ticketId] || [];
      return groupFieldsBySection(sections, ticket.registrationFields || []);
    },
    hasSections(ticket) {
      const steps = this.getTicketSteps(ticket);
      return steps.length > 1 || (steps.length === 1 && steps[0].title !== null);
    },
    ticketStepIsValid(ticket, stepIndex) {
      const steps = this.getTicketSteps(ticket);
      const step = steps[stepIndex];
      if (!step) return true;
      return step.fields.every(f => {
        if (!f.required) return true;
        if (!this.isCheckoutFieldVisible(f, ticket)) return true;
        const val = ticket.extraInfo && ticket.extraInfo[f.formattedName];
        return val !== null && val !== undefined && val !== '';
      });
    },
    nextTicketStep(ticket) {
      const ticketId = ticket.id || ticket._id;
      const steps = this.getTicketSteps(ticket);
      const current = this.currentTicketStep[ticketId] || 1;
      const stepIndex = current - 1;
      if (!this.ticketStepIsValid(ticket, stepIndex)) {
        this.show({ color: 'error', text: 'Por favor completa todos los campos obligatorios de esta sección.' });
        return;
      }
      if (current < steps.length) {
        this.$set(this.currentTicketStep, ticketId, current + 1);
      }
    },
    prevTicketStep(ticket) {
      const ticketId = ticket.id || ticket._id;
      const current = this.currentTicketStep[ticketId] || 1;
      if (current > 1) {
        this.$set(this.currentTicketStep, ticketId, current - 1);
      }
    },
    getExtraInfo(registrationFields) {      const extraFields = {};
      registrationFields.forEach((field) => {
        extraFields[field.formattedName] = null;
      });
      return extraFields;
    },
    isCheckoutFieldVisible(field, ticket) {
      // Expanded instances are always visible (already filtered by getExpandedCheckoutFields)
      if (field._instanceKey) return true;
      if (!field.parentField) return true;
      const parent = ticket.registrationFields.find((f) => f._id == field.parentField);
      if (!parent) return false;
      if (!this.isCheckoutFieldVisible(parent, ticket)) return false;
      // If parent is multi-select, visibility handled by getExpandedCheckoutFields
      if (parent.allowMultiple) return false;
      const parentValue = ticket.extraInfo[parent.formattedName];
      if (!parentValue) return false;
      const co =
        field.conditionalOptions instanceof Map
          ? Object.fromEntries(field.conditionalOptions)
          : field.conditionalOptions;
      if (!co) return false;
      return Object.prototype.hasOwnProperty.call(co, parentValue) && co[parentValue].length > 0;
    },
    getCheckoutFieldItems(field, ticket) {
      // Expanded instances already have their dynamic options baked in
      if (field._dynamicOptions !== undefined) return field._dynamicOptions;
      if (field.parentField && field.conditionalOptions) {
        const parent = ticket.registrationFields.find((f) => f._id == field.parentField);
        if (parent && ticket.extraInfo[parent.formattedName]) {
          const co =
            field.conditionalOptions instanceof Map
              ? Object.fromEntries(field.conditionalOptions)
              : field.conditionalOptions;
          return co[ticket.extraInfo[parent.formattedName]] || [];
        }
        return [];
      }
      return field.options;
    },
    clearCheckoutChildFields(field, ticket) {
      ticket.registrationFields.forEach((f) => {
        if (
          f.parentField &&
          (f.parentField == field._id ||
            (f.parentField._id && f.parentField._id == field._id))
        ) {
          this.$set(ticket.extraInfo, f.formattedName, null);
          // Clear expanded instance keys for this child
          Object.keys(ticket.extraInfo).forEach((k) => {
            if (k.startsWith(f.formattedName + '__')) {
              this.$set(ticket.extraInfo, k, null);
            }
          });
          this.clearCheckoutChildFields(f, ticket);
        }
      });
    },
    getExpandedCheckoutFields(ticket) {
      const result = [];
      const sortedFields = [...ticket.registrationFields].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      for (const field of sortedFields) {
        const parentId = field.parentField && field.parentField._id
          ? field.parentField._id
          : field.parentField;
        const parent = parentId
          ? sortedFields.find((f) => f._id == parentId)
          : null;
        if (parent && parent.allowMultiple) {
          // Expand: one instance per selected parent value
          const parentValues = ticket.extraInfo[parent.formattedName];
          if (!Array.isArray(parentValues) || parentValues.length === 0) continue;
          const co = field.conditionalOptions instanceof Map
            ? Object.fromEntries(field.conditionalOptions)
            : field.conditionalOptions;
          if (!co) continue;
          for (const pv of parentValues) {
            if (co[pv] && co[pv].length > 0) {
              const expandedKey = field.formattedName + '__' + pv;
              result.push({
                ...field,
                _instanceKey: pv,
                _instanceLabel: pv,
                _dynamicOptions: co[pv],
                formattedName: expandedKey,
              });
            }
          }
        } else {
          result.push(field);
        }
      }
      return result;
    },
    handleMultiSelectParentChange(field, ticket) {
      const selectedValues = ticket.extraInfo[field.formattedName] || [];
      ticket.registrationFields.forEach((f) => {
        const childParentId = f.parentField && f.parentField._id ? f.parentField._id : f.parentField;
        if (childParentId == field._id) {
          const co = f.conditionalOptions instanceof Map
            ? Object.fromEntries(f.conditionalOptions)
            : f.conditionalOptions;
          if (!co) return;
          // Initialize keys for newly selected values
          selectedValues.forEach((pv) => {
            if (co[pv]) {
              const expandedKey = f.formattedName + '__' + pv;
              if (!Object.prototype.hasOwnProperty.call(ticket.extraInfo, expandedKey)) {
                this.$set(ticket.extraInfo, expandedKey, null);
              }
            }
          });
          // Remove keys for deselected values
          Object.keys(ticket.extraInfo).forEach((k) => {
            if (k.startsWith(f.formattedName + '__')) {
              const pv = k.slice(f.formattedName.length + 2);
              if (!selectedValues.includes(pv)) {
                this.$delete(ticket.extraInfo, k);
              }
            }
          });
        }
      });
    },
    async addCombo(combo) {
      const comboId = combo._id;
      this.loading();
      try {
        const response = await this.axios({
          method: 'POST',
          url: '/checkout/event/combo-management',
          data: {
            comboId,
            orderId: this.order.id,
          },
        });

        if (response.status === 200) {
          this.selectedCombos[comboId] = this.selectedCombos[comboId] + 1 || 1;

          const {
            tickets,
            order: { items },
          } = response.data;
          this.tickets = this.formatTickets(tickets);
          this.ticketsToBuy++;
          this.panel.push(this.panel.length);
          this.order.coupon.percentOff = 0;
          this.coupon = '';
          this.couponApplied = false;
          this.setSuccessToInitial('coupon');
          this.success.coupon.success = false;

          const itemsToPush = [];

          items.forEach((item) => {
            if (
              !this.order.tickets.find((ticket) => ticket.itemId === item._id)
            ) {
              itemsToPush.push(item);
            }
          });

          for (let itemToPush of itemsToPush) {
            const ticket = this.getTicketById(combo.ticket, this.order.items);
            const {
              ticket: { registrationFields },
            } = itemToPush;
            const extraInfo =
              registrationFields?.length > 0
                ? this.getExtraInfo(registrationFields)
                : {};

            this.order.tickets.push({
              id: combo.ticket,
              itemId: itemToPush._id,
              price: itemToPush.totalPaid,
              name: itemToPush.ticket.name,
              registrationFields: registrationFields || [],
              extraInfo,
              attendeeInformation: {
                name: '',
                lastName: '',
                email: '',
                confirmEmail: '',
              },
            });

            if (ticket) {
              this.order.items = [
                ...this.order.items.map((item) =>
                  item.id === itemToPush.ticket._id
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
                ),
              ];
            } else {
              this.order.items.push({
                id: itemToPush.ticket._id,
                name: itemToPush.ticket.name,
                price: itemToPush.totalPaid,
                quantity: 1,
              });
            }
          }
        }
      } catch (error) {
        console.log('**************');
        console.log(error);
      } finally {
        this.loaded();
      }
    },
    async addTicket({ id, price, name, membersOnly = false }) {
      if (this.isResumingOrder) return;
      if (
        this.isTicketAvailable(id) &&
        this.ticketsToBuy < this.maxTicketsUserCanBuy
      ) {
        try {
          this.loading();
          const response = await this.axios.post(
            Endpoints.checkoutSetTicketToOrder,
            {
              item: {
                order: this.order.id,
                ticket: id,
                member:
                  this.user &&
                  (this.user.role === 'MEMBER' ||
                    this.user.role === 'MEMBERSHIP_USER')
                    ? this.user._id
                    : undefined,
              },
            }
          );

          if (response.status === 200) {
            const {
              tickets,
              order: { items, member = {} },
            } = response.data;
            this.tickets = this.formatTickets(tickets);
            this.applyTicketLockFilter();
            this.ticketsToBuy++;
            this.panel.push(this.panel.length);
            this.order.coupon.percentOff = 0;
            this.coupon = '';
            this.couponApplied = false;
            this.setSuccessToInitial('coupon');
            this.success.coupon.success = false;

            const ticket = this.getTicketById(id, this.order.items);
            const [itemToPush] =
              items.filter(
                (item) =>
                  !this.order.tickets.find(
                    (ticket) => ticket.itemId === item._id
                  )
              ) || [];
            const {
              ticket: { registrationFields },
            } = itemToPush;
            const extraInfo =
              registrationFields?.length > 0
                ? this.getExtraInfo(registrationFields)
                : {};

            const {
              name: userName,
              firstLastname: userLastName,
              email: userEmail,
            } = member;
            const membersOnlyTicket = membersOnly;
            this.order.tickets.push({
              id,
              itemId: itemToPush._id,
              price,
              name,
              registrationFields: registrationFields || [],
              extraInfo,
              attendeeInformation: {
                name: membersOnlyTicket ? userName : '',
                lastName: membersOnlyTicket ? userLastName : '',
                email: membersOnlyTicket ? userEmail : '',
                confirmEmail: '',
              },
              membersOnly,
            });

            if (ticket) {
              this.order.items = [
                ...this.order.items.map((item) =>
                  item.id === id
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
                ),
              ];
            } else {
              this.order.items.push({
                id,
                name,
                price,
                quantity: 1,
              });
            }
          }
        } catch (error) {
          console.log('**************');
          console.log(error);
        } finally {
          this.loaded();
        }
      }
    },
    async removeCombo(combo) {
      const comboId = combo._id;
      const anyMatchingTicket = this.order.tickets.some(
        (ticket) => ticket.id === combo.ticket
      );

      try {
        this.loading();

        if (this.ticketsToBuy !== 0 && anyMatchingTicket) {
          const response = await this.axios({
            method: 'DELETE',
            url: '/checkout/event/combo-management',
            data: {
              comboId,
              orderId: this.order.id,
            },
          });
          if (response.status === 200) {
            this.ticketsToBuy--;
            this.selectedCombos[comboId]--;

            if (this.selectedCombos[comboId] === 0) {
              delete this.selectedCombos[comboId];
            }

            for (let i = 0; i < combo.discountedQuantity; i++) {
              let { items } = this.orderState;
              const { tickets } = response.data;
              this.tickets = this.formatTickets(tickets);
              items = items
                .map((ticket) =>
                  ticket.id === combo.ticket
                    ? { ...ticket, quantity: ticket.quantity-- }
                    : ticket
                )
                .filter((ticket) => ticket.quantity === 0);
              const ticketIndexToDelete = this.order.tickets.findIndex(
                (ticket) => ticket.id === combo.ticket
              );
              ticketIndexToDelete !== -1 &&
                this.order.tickets.splice(ticketIndexToDelete, 1);

              if (ticketIndexToDelete !== -1) {
                this.order.items.splice(ticketIndexToDelete, 1);
              }

              this.panel.splice(-1, 1);
              this.order.coupon.percentOff = 0;
              this.coupon = '';
              this.couponApplied = false;
              this.setSuccessToInitial('coupon');
              this.success.coupon.success = false;
            }
          }
        }
      } catch (error) {
        console.log('**************');
        console.log(error);
      } finally {
        this.loaded();
      }
    },
    async removeTicket(ticketId) {
      if (this.isResumingOrder) return;
      const anyMatchingTicket = this.order.tickets.some(
        (ticket) => ticket.id === ticketId
      );
      try {
        this.loading();
        if (this.ticketsToBuy !== 0 && anyMatchingTicket) {
          const response = await this.axios.delete(
            Endpoints.checkoutSetTicketToOrder,
            {
              data: {
                item: {
                  order: this.order.id,
                  ticket: ticketId,
                },
              },
            }
          );
          if (response.status === 200) {
            let { items } = this.orderState;
            const { tickets } = response.data;
            this.tickets = this.formatTickets(tickets);
            this.applyTicketLockFilter();
            items = items
              .map((ticket) =>
                ticket.id === ticketId
                  ? { ...ticket, quantity: ticket.quantity-- }
                  : ticket
              )
              .filter((ticket) => ticket.quantity === 0);
            const ticketIndexToDelete = this.order.tickets.findIndex(
              (ticket) => ticket.id === ticketId
            );
            ticketIndexToDelete !== -1 &&
              this.order.tickets.splice(ticketIndexToDelete, 1);
            this.panel.splice(-1, 1);
            this.ticketsToBuy--;
            this.order.coupon.percentOff = 0;
            this.coupon = '';
            this.couponApplied = false;
            this.setSuccessToInitial('coupon');
            this.success.coupon.success = false;
          }
        }
      } catch (error) {
        console.log('**************');
        console.log(error);
      } finally {
        this.loaded();
      }
    },
    async addCoupon() {
      try {
        this.loading();
        const couponCode = this.coupon.trim();

        if (couponCode) {
          const response = await this.axios.post(Endpoints.couponValidate, {
            coupon: {
              tickets: this.tickets,
              id: this.id,
              event: this.eventId,
              code: couponCode,
              order: this.order.id,
            },
          });

          if (response.status === 200) {
            const { coupon } = response.data;
            this.order.coupon = coupon;
            this.setErrorToInitial('coupon');

            const orderIds = this.order.tickets.map((ticket) => ticket.id);
            const couponTickets = this.order.coupon.tickets.map(
              (ticket) => ticket
            );
            //console.log("order");
            //console.log(orderIds);
            // console.log("cupon");
            // console.log(couponTickets);

            if (couponTickets != '') {
              const allIdsPresent = orderIds.every((id) =>
                couponTickets.includes(id)
              );
              console.log('lleno');
              if (allIdsPresent) {
                this.success.coupon = {
                  success: true,
                  message: `${coupon.percentOff}% de descuento, se aplicará al finalizar la compra.`,
                };
                this.couponApplied = true;
              } else {
                this.order.coupon.percentOff = 0;
                this.setSuccessToInitial('coupon');
                this.errors.coupon = {
                  error: true,
                  message: 'El cupón no es válido',
                };
              }
            } else {
              this.success.coupon = {
                success: true,
                message: `${coupon.percentOff}% de descuento, se aplicará al finalizar la compra.`,
              };
              this.couponApplied = true;
            }

            //console.log(allIdsPresent);
            ///
          }
        } else {
          this.setSuccessToInitial('coupon');
          this.errors.coupon = {
            error: true,
            message: 'Ingrese el código del cupón',
          };
        }
      } catch (error) {
        const response = error.response;
        this.setSuccessToInitial('coupon');
        this.errors.coupon = {
          error: true,
          message:
            response && response.data && response.data.error
              ? response.data.error.message
              : 'El cupón no es válido',
        };
      } finally {
        this.loaded();
      }
    },

    paymentSelection(toggle, paymentName) {
      if (paymentName == 'CREDIT_CARD') {
        this.cardPaymentIntentId = '';
      }
      this.order.paymentInformation.paymentMethod = paymentName;
      toggle();
    },
    setErrorToInitial(errorKey) {
      if (this.errors[errorKey].error) {
        this.errors[errorKey] = {
          error: false,
          message: '',
        };
      }
    },
    setSuccessToInitial(successKey) {
      if (this.success[successKey].success) {
        this.success[successKey] = {
          success: true,
          message: '',
        };
      }
    },
    formatEmail(ticket) {
      ticket.attendeeInformation.email = ticket.attendeeInformation.email
        .toLowerCase()
        .trim();
    },
    showFacturaDialog() {
      if (!this.factura) {
        this.factura = true;
        this.facturaDialog = true;
      } else {
        this.factura = false;
      }
    },
    async setAttendeeInformation() {
      if (!this.$refs.ticketsForm.validate()) return;
      let items = [];

      for (const ticket of this.order.tickets) {
        let extraInfoFiles = new FormData();
        extraInfoFiles.append('order', this.order.id);
        extraInfoFiles.append('item', ticket.itemId);
        let extraInfoWithoutFiles = {};
        Object.keys(ticket.extraInfo).forEach((key) => {
          if (!(ticket.extraInfo[key] instanceof File)) {
            extraInfoWithoutFiles[key] = ticket.extraInfo[key];
          } else {
            extraInfoFiles.append(key, ticket.extraInfo[key]);
          }
        });
        items.push({
          _id: ticket.itemId,
          attendeeInformation: {
            name: ticket.attendeeInformation.name,
            lastName: ticket.attendeeInformation.lastName,
            email: ticket.attendeeInformation.email,
            ...extraInfoWithoutFiles,
          },
        });

        try {
          const payload = {
            order: {
              id: this.order.id,
              items: [
                {
                  _id: ticket.itemId,
                  attendeeInformation: {
                    name: ticket.attendeeInformation.name,
                    lastName: ticket.attendeeInformation.lastName,
                    email: ticket.attendeeInformation.email,
                    ...extraInfoWithoutFiles,
                  },
                },
              ],
            },
          };
          await this.axios.post(
            Endpoints.checkoutSetAttendeeInformation,
            payload
          );

          await this.axios.post(
            Endpoints.checkoutSetAttendeeDocs,
            extraInfoFiles
          );
        } catch (error) {
          console.log('******************');
          console.log(error);
        }
      }

      this.total = this.totalPurchase.number;
      // Comprobar si se usó un cupón del 100% de descuento para avanzar al último paso del checkout
      if (
        this.order.coupon.percentOff == 100 ||
        this.paymentModality ||
        this.totalPurchase.number <= 0
      ) {
        this.order.paymentInformation.paymentMethod = 'FREE';
        this.currentStep = this.currentStep + 2;
      } else {
        this.currentStep++;
      }
    },
    async updateCoupon() {
      const { id: _, ...couponRest } = this.order.coupon;
      let updatedApplications = this.order.coupon?.applications || null;
      let couponLimitsCount = this.order.coupon?.limit || null;
      let updatedStatus = 'ACTIVE';

      if (updatedApplications >= 0) {
        updatedApplications++;
      }

      // if (couponLimitsCount) {
      //   couponLimitsCount--;
      //   if (couponLimitsCount <= 0) {
      //     updatedStatus = "EXPIRED";
      //   }
      // }

      const data = {
        coupon: {
          ...couponRest,
          applications: updatedApplications,
          status: updatedStatus,
          limit: couponLimitsCount,
        },
      };

      const response = await this.axios.put(
        Endpoints.couponsId.replace(':id', this.order.coupon.id),
        data
      );

      if (response.status === 200) {
        const { coupon: responseCoupon } = response.data;

        // Aquí actualizamos la variable coupon si el ID coincide
        if (this.order.coupon.id === responseCoupon.id) {
          this.order.coupon = responseCoupon;
        }
      }
    },
    async finishBuying() {
      // Obtener métodos de pago disponibles
      const { Free, Cash, CreditCard, BankTransfer, Peibo } = this.paymentMethodsKeys;
      // Obtener el método de pago usado en la orden
      const { paymentMethod } = this.order.paymentInformation;
      // Relacionar la función que se va a ejecutar con el nombre del método de pago
      const cases = {
        [Free]: this.excecuteFreeRegistration,
        [Cash]: this.executeCashPayment,
        [CreditCard]: this.executeCardPayment,
        [BankTransfer]: this.executeBankTransferPayment,
        [Peibo]: this.executePeiboPayment,
      };
      //console.log(this.order.coupon)

      if (this.order.coupon.id) {
        await this.updateCoupon();
      }
      // Comprobar que existe el método de pago y ejecutar la función que le corresponde a ese método de pago
      cases[paymentMethod] && (await cases[paymentMethod]());
    },
    async excecuteFreeRegistration() {
      this.loading();
      try {
        let response = await this.axios({
          method: 'post',
          url: Endpoints.excecuteFreeRegistration,
          json: true,
          data: {
            order: {
              orderId: this.order.id,
              eventId: this.eventId,
              paymentInformation: {
                name:
                  this.order.tickets[0].attendeeInformation.name +
                  ' ' +
                  this.order.tickets[0].attendeeInformation.lastName,
                email: this.order.tickets[0].attendeeInformation.email,
              },
            },
          },
        });
        console.log('Respuesta al registrar una transacción gratuita');
        console.log(response);
        this.currentStep++;
      } catch (error) {
        console.log('Respuesta del error');
        console.log(error);
        this.show({
          text: this.getPaymentErrorMessage(
            error,
            'No se pudo completar el registro del evento.'
          ),
          color: 'error',
        });
        this.currentStep = this.currentStep - 2;
      } finally {
        this.loaded();
      }
    },
    closeErrorCardModal() {
      this.isOpenErrorCardModal = false;
      this.errorMessage = '';
      this.errorCode = '';
    },
    /**
     * Ejecutar cuando se usa el método de pago de tarjeta para finalizar todos los pasos del checkout
     */
    async executeCardPayment() {
      try {
        this.loading();
        let response = await this.axios({
          method: 'post',
          url: Endpoints.executeCardPayement,
          json: true,
          data: {
            payment: {
              paymentIntentId: this.cardPaymentIntentId,
              selectedPlan: this.installments.selected,
              connectedAccount: this.stripeAccount,
            },
          },
        });

        await this.setOrderPaymentInformation();

        if (
          response.data.payment.next_action &&
          response.data.payment.next_action.redirect_to_url.url
        ) {
          this.iframeDialog = true;
          this.clientSecret = response.data.payment.client_secret;
          this.iframeSource =
            response.data.payment.next_action.redirect_to_url.url;
        } else {
          this.show({
            text: 'Registro realizado correctamente',
            color: 'primary',
          });
          this.currentStep++;
        }
      } catch (error) {
        let errorCode = error?.response?.data?.error?.code || null;
        const backendMessage = this.getPaymentErrorMessage(error, null);
        this.errorMessage = '';
        // console.log(JSON.stringify(error.response));

        if (error.declineCode && CardErrors[error.declineCode]) {
          this.errorMessage = CardErrors[error.declineCode];
          this.errorCode = error.declineCode;
        } else if (errorCode && CardErrors[errorCode]) {
          this.errorMessage = CardErrors[errorCode];
          this.errorCode = errorCode;
        } else {
          this.errorMessage =
            'El pago falló porque el banco emisor lo rechazó. Comunicate con el banco emisor para obtener más información.';
          this.errorCode = '';
        }

        if ([403, 404].includes(error?.response?.status) && backendMessage) {
          this.show({ text: backendMessage, color: 'error' });
        }
        this.isOpenErrorCardModal = true;
        this.currentStep--;
        this.stripeComponentKey++;
        this.order.paymentInformation.cardName = '';
        this.termsOfUSe.terms = false;
        this.billingPolitics.terms = false;
        this.source = '';
      } finally {
        this.loaded();
      }
    },
    /**
     * Ejecutar en el paso 3 del checkout
     * Solo se ejecuta una acción diferente cuando se usa el método de pago de oxxo
     */
    async executePaymentAction() {
      await this.setOrderPaymentInformation();

      this.currentStep++;
    },
    /**
     * Ejecutar cuando el usuario se quiere regresar del paso 4 al paso 2
     * Verifica si el evento es gratuito o el usuario usó un cupón del 100% para saber si se regresa al paso 2, saltandose el paso 3 del checkout
     */
    returnFromStepFour() {
      if (
        this.order.coupon.percentOff == 100 ||
        this.paymentModality ||
        this.totalPurchase.number <= 0
      ) {
        this.currentStep = this.currentStep - 2;
      } else {
        this.currentStep--;
      }
    },
    /**
     * Ejecutar cuando se usa el método de pago de oxxo para finalizar todos los pasos del checkout
     */
    async executeCashPayment() {
      try {
        this.loading();

        let response = await this.axios({
          method: 'post',
          url: Endpoints.cashPaymentIntent,
          json: true,
          data: {
            paymentMethod: { total: this.total },
            orderId: this.order.id,
          },
        });
        this.clientSecret = response.data.paymentIntent.clientSecret;

        let stripe;
        if (this.stripeAccount) {
          stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY, {
            stripeAccount: this.stripeAccount,
          });
        } else {
          stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY);
        }
        //await this.setOrderPaymentInformation();

        const result = await stripe.confirmOxxoPayment(this.clientSecret, {
          payment_method: {
            billing_details: {
              name: `${this.order.paymentInformation.name} ${this.order.paymentInformation.lastName}`,
              email: this.order.paymentInformation.email,
            },
          },
        });
        if (result.error) {
          console.log('MENSAJE DE ERROR');
          console.log(result.error);
          this.show({
            text: '¡No se ha podido realizar la transacción!',
            color: 'error',
          });
        } else {
          console.log('stripe result', result);
          await this.axios({
            method: 'PUT',
            url: `/orders/set-payment-reference/${this.order.id}`,
            data: {
              paymentReference:
                result.paymentIntent.next_action.oxxo_display_details
                  .hosted_voucher_url,
            },
          });
          this.show({
            text: 'Registro realizado correctamente',
            color: 'primary',
          });
        }
        this.currentStep++;
      } catch (error) {
        this.show({
          text: this.getPaymentErrorMessage(
            error,
            '¡No se ha podido realizar la transacción!'
          ),
          color: 'error',
        });
      } finally {
        this.loaded();
      }
    },
    async executeBankTransferPayment() {
      try {
        this.loading();

        //await this.setOrderPaymentInformation();

        let response = await this.axios({
          method: 'post',
          url: Endpoints.bankTransferPaymentIntent,
          json: true,
          data: {
            paymentMethod: { total: this.total },
            customer: {
              name: `${this.order.paymentInformation.name} ${this.order.paymentInformation.lastName}`,
              email: this.order.paymentInformation.email,
            },
            orderId: this.order.id,
          },
        });

        this.clientSecret = response.data.paymentIntent.clientSecret;

        let stripe;
        if (this.stripeAccount) {
          stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY, {
            stripeAccount: this.stripeAccount,
          });
        } else {
          stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY);
        }

        // const stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY, {
        //   stripeAccount: this.stripeAccount,
        //   apiVersion: "2020-08-27;customer_balance_payment_method_beta=v2",
        //   betas: ["customer_balance_beta_1"],
        // });
        let isAmpi = [
          '62b622c66a7441ae20159d7d',
          '6297b0fec7bf8b6f826313be',
        ].includes(this.organizationId);

        const disabledOrganizationActions =
          isAmpi || this.isImefOrganization(this.organizationId);
        const handleActions = disabledOrganizationActions ? false : true;
        console.log(handleActions);
        const result = await stripe.confirmCustomerBalancePayment(
          this.clientSecret,
          {
            payment_method: {
              billing_details: {
                name: `${this.order.paymentInformation.name} ${this.order.paymentInformation.lastName}`,
                email: this.order.paymentInformation.email,
              },
            },
            // payment_method_options: {
            //   customer_balance: {
            //     funding_type: "bank_transfer",
            //     bank_transfer: {
            //     },
            //   },
            // },
          },
          {
            handleActions: handleActions,
          }
        );

        if (result.error) {
          this.show({
            text: '¡No se ha podido realizar la transacción!',
            color: 'error',
          });
        } else {
          await this.axios({
            method: 'PUT',
            url: `/orders/set-payment-reference/${this.order.id}`,
            data: {
              paymentReference:
                result.paymentIntent.next_action
                  .display_bank_transfer_instructions.hosted_instructions_url,
            },
          });
          this.show({
            text: 'Registro realizado correctamente',
            color: 'primary',
          });
          if (disabledOrganizationActions) {
            this.voucherDialog = true;
            this.bankTransferInstructions =
              result.paymentIntent.next_action.display_bank_transfer_instructions;
            this.bankTransferDescription = result.paymentIntent.description
              ? result.paymentIntent.description
              : this.order.id;
          } else {
            this.currentStep++;
          }
        }
      } catch (error) {
        this.show({
          text: this.getPaymentErrorMessage(
            error,
            '¡No se ha podido realizar la transacción!'
          ),
          color: 'error',
        });
      } finally {
        this.loaded();
      }
    },

    closeVoucherDialog() {
      (this.voucherDialog = false), this.currentStep++;
    },

    closePeiboDialog() {
      this.peiboDialog = false;
      this.currentStep++;
    },

    async executePeiboPayment() {
      try {
        this.loading();
        await this.setOrderPaymentInformation();

        const payloadData = {
          orderId: this.order.id,
        };

        // Si el usuario no tiene peiboClabe, incluir los datos del beneficiario
        if (!this.user || !this.user.peiboClabe) {
          payloadData.beneficiary_name = this.peiboData.beneficiary_name;
          payloadData.beneficiary_tax_id = this.peiboData.beneficiary_tax_id;
        }

        const response = await this.axios({
          method: 'POST',
          url: '/payments/peibo/payment-intent',
          data: payloadData,
        });

        this.peiboClabe = response.data.clabe;
        this.peiboDialog = true;
        this.show({
          text: 'Orden creada correctamente. Por favor completa el pago siguiendo las instrucciones.',
          color: 'primary',
        });
      } catch (error) {
        console.log('error', error);
        this.show({
          text: this.getPaymentErrorMessage(
            error,
            '¡No se ha podido procesar la orden!'
          ),
          color: 'error',
        });
      } finally {
        this.loaded();
      }
    },

    async setOrderPaymentInformation() {
      this.order.paymentInformation.needsInvoice = this.acceptBill;
      // establecer meses sin intereses en la orden si están habilitados
      if (this.installments.enable) {
        this.order['orderInstallments'] = this.installments.selected;
      }

      // cambiar valores para id de imef en prod
      if (this.isImefOrganization(this.organizationId)) {
        this.order.paymentInformation.acceptImefPolitics =
          this.shareDataPolitics.terms;
      }
      try {
        this.loading();
        await this.axios({
          method: 'post',
          url: Endpoints.checkoutSetPaymentInformation,
          json: true,
          data: {
            order: {
              id: this.order.id,
              paymentInformation: this.order.paymentInformation,
              orderInstallments: this.order.orderInstallments,
            },
          },
        });
      } catch (error) {
        console.log('******************');
        console.log(error);
      } finally {
        this.loaded();
      }
    },
    triggerErrorAlert(error) {
      this.snackbar = true;
      this.snackbarText = error.message;
      this.source = '';
      this.cardPaymentIntentId = '';
      this.stripeComponentKey++;
    },
    getPaymentErrorMessage(error, fallback) {
      const responseData = error?.response?.data || {};
      const errorData = responseData.error;
      if (typeof errorData === 'string') return errorData;
      return errorData?.message || responseData.message || fallback;
    },
    routeValidation(route) {
      const regexpresion = new RegExp('ampi', 'i');
      const regexpresion1 = new RegExp(
        'Asociación Mexicana de Profesionales Inmobiliarios',
        'i'
      );
      return regexpresion.test(route) || regexpresion1.test(route);
    },
    async updateEventExpirationDateWebHook() {
      try {
        const response = await this.axios({
          method: 'PUT',
          url: '/checkout/event/order-management/order-expiration',
          data: {
            orderId: this.order.id,
            orderWebHookId: this.currentOrderWHToken
          }
        });
        if (response) {
          this.currentOrderWHToken = response.data.data
          this.setEventWebHookToken(response.data.data)
        }
      } catch (error) {
        throw new Error('No se ha podido actualizar el webhook de la orden')
      }
    }
  },
  computed: {
    ...mapState('loader', ['loaderVisible']),
    ...mapState('user', ['user']),
    ...mapState('order', []),
    dateExpireOrder() {
      let expireIn = moment().set('hour', 72);
      return `${expireIn.format('h:mm')} hrs del dia ${expireIn.get(
        'date'
      )} de ${expireIn.format('MMMM')}`;
    },
    orderState() {
      return {
        items: this.order.items,
        hasItems: this.order.items.length > 0,
        tickets: this.order.tickets,
        hasTickets: this.order.tickets.length > 0,
      };
    },
    isResumingOrder() {
      return !!this.pendingOrderId;
    },
    discount() {
      const total = this.totalPurchase.number;
      const discount = total * (this.order.coupon.percentOff / 100);
      return {
        string: this.formatNumber(discount),
        number: discount,
      };
    },
    paymentMethodList() {
      let paymentMethods = [...this.paymentMethods]
        .map((method) => {
          if (method.name != 'CASH') return method;
          return {
            ...method,
            active: this.totalPurchaseWithDiscount.number <= 10000,
          };
        })
        .filter((method) => method.active == true);

      if (isAsofomOrganization(this.organizationId, this.user && this.user.headOffice && this.user.headOffice._id)) {
        paymentMethods.push({ name: 'PEIBO', icon: 'fas fa-landmark', active: true });
      }

      return paymentMethods;
    },
    totalPurchase() {
      let total = 0;
      const { tickets, hasTickets } = this.orderState;
      hasTickets &&
        tickets.forEach(({ price }) => {
          total += price;
        });
      return {
        string: this.formatNumber(total),
        number: total,
      };
    },
    totalPurchaseWithDiscount() {
      const total = this.totalPurchase.number;
      const discount = this.discount.number;
      const totalWithDiscount = total - discount;
      return {
        string: this.formatNumber(totalWithDiscount),
        number: totalWithDiscount,
      };
    },
    disableContinueBuyButton() {
      const { name, lastName, email, paymentMethod } =
        this.order.paymentInformation;

      let commonRules;

      if (
        ['62b622c66a7441ae20159d7d', '6297b0fec7bf8b6f826313be'].includes(
          this.organizationId
        ) &&
        this.offerBilling
      ) {
        commonRules =
          !this.termsOfUSe.terms ||
          !this.billingPolitics.terms ||
          !lastName ||
          !email ||
          !name ||
          !paymentMethod;
        !(this.acceptBill == true || this.declineBill == true);
      } else {
        commonRules =
          !this.termsOfUSe.terms ||
          !lastName ||
          !email ||
          !name ||
          !paymentMethod;
      }

      const creditCardRules =
        paymentMethod === this.paymentMethodsKeys.CreditCard &&
        !this.cardPaymentIntentId;

      const peiboRules =
        paymentMethod === this.paymentMethodsKeys.Peibo &&
        (!this.user || !this.user.peiboClabe) &&
        (!this.peiboData.beneficiary_name || !this.peiboData.beneficiary_tax_id);

      return commonRules || creditCardRules || peiboRules;
    },
    counterValues() {
      const counter = {};
      const { items, hasItems } = this.orderState;
      hasItems &&
        items.forEach(({ id, quantity }) => {
          counter[id] = quantity;
        });
      return counter;
    },
    formasDePago() {
      return [
        '01 Efectivo',
        '03 Transferencia electrónica de fondos ( Incluye SPEI)',
        '04 Tarjeta de crédito',
        '28 Tarjeta de débito',
      ];
    },
    ticketsToBuyIsZero() {
      return this.ticketsToBuy === 0;
    },
    /**
     * Función que toma el tamaño de la pantalla del dispositivo para dar tamaño a los iconos (v-dialog de facturación).
     */
    getBigSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'font-size:2.5em';
        case 'sm':
          return 'font-size:2.7em';
        case 'md':
          return 'font-size:2.7em';
        case 'lg':
          return 'font-size:3em';
        case 'xl':
          return 'font-size:3.2em';
      }
    },
    /**
     * Función que toma el tamaño de la pantalla del dispositivo para dar tamaño a los iconos de métodos de pago
     */
    getSizePaymentsMethodsIcons() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'font-size:2.5em';
        case 'sm':
          return 'font-size:2.5em';
        case 'md':
          return 'font-size:2.3em';
        case 'lg':
          return 'font-size:2.3em';
        case 'xl':
          return 'font-size:2.5em';
      }
    },
    getSizeFinalIcon() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'font-size:4.5em';
        case 'sm':
          return 'font-size:4.5em';
        case 'md':
          return 'font-size:5em';
        case 'lg':
          return 'font-size:6.3em';
        case 'xl':
          return 'font-size:6.5em';
      }
    },
  },
  async created() {
    this.loading();
    if (
      this.user &&
      (this.user.role == 'MEMBER' || this.user.role == 'MEMBERSHIP_USER')
    ) {
      await this.getAffiliationTypes();
    }
    if (!this.isResumingOrder) {
      await this.getCombos();
    }
    const eventLoaded = await this.setEventInfo();
    if (!eventLoaded) {
      this.loaded();
      return;
    }

    // Solo obtener tickets comprados para la organización específica
    if (
      this.organizationId === '66fb2d896646ca001cb93b3f' &&
      this.user &&
      (this.user.role == 'MEMBER' || this.user.role == 'MEMBERSHIP_USER')
    ) {
      await this.getMemberPurchasedTickets();
    }

    if (this.isResumingOrder) {
      // Resume an existing PAYMENT_PENDING order without recreating it.
      // Skips order creation, keeps the order in PAYMENT_PENDING and locks
      // the ticket selection so the member only confirms attendee info and pays.
      const ok = await this.hydrateFromPendingOrder();
      if (ok) {
        this.currentStep = 2;
      }
    } else {
      await this.createOrder();
    }
    this.window.addEventListener('message', this.validate3sSecure);
    this.loaded();
  },

  async mounted() {
    this.renewOrderIntervalId = setInterval(async () => {
      await this.updateEventExpirationDateWebHook()
      console.log('Event order expiration updated')
    }, 28 * 60000); // Renovar la fecha de expiración de la orden cada 20 minutos
  },

  beforeDestroy() {
    if (this.renewOrderIntervalId) {
      clearInterval(this.renewOrderIntervalId);
      this.deleteEventWebHookToken()
    }
  }
};
</script>
<style scoped>
.relative-left {
  position: relative;
  left: 0%;
}

.texto-rojo {
  color: red;
}

.access-item-border {
  border: 1.2px solid !important;
  border-color: rgb(241, 241, 241) !important;
}

.label_move {
  position: relative;
  display: inline-block;
  animation: 4s linear 0s infinite alternate move;
  -webkit-transition-duration: 4s;
}

@keyframes move {
  0%,
  25% {
    transform: translateX(0%);
    left: 0%;
  }

  75%,
  100% {
    transform: translateX(-100%);
    left: 100%;
  }
}
</style>
